!function () {
	let e, t, i;

	class s extends HTMLElement {
		constructor() {
			super(), this.purchaseAmount = this.getAttribute("data-purchase-amount")
		}

		connectedCallback() {
			if (window.Alma) this.initAlma(); else {
				let e = new MutationObserver(() => {
					window.Alma && (this.initAlma(), e.disconnect())
				});
				e.observe(document.documentElement, {childList: !0, subtree: !0})
			}
		}

		initAlma() {
			let e = Alma.Widgets.initialize("11yMbsX2Btj4LPEGYaPkZF6M96KhF15Xvm", Alma.ApiMode.LIVE), t = {
				container: "#alma-widget",
				purchaseAmount: this.purchaseAmount,
				locale: Shopify.locale,
				hideIfNotEligible: !1
			};
			e.add(Alma.Widgets.PaymentPlans, {
				...t,
				plans: [{installmentsCount: 3, minAmount: 1e4, maxAmount: 999999}, {
					installmentsCount: 4,
					minAmount: 2e4,
					maxAmount: 999999
				}]
			})
		}

		updatePurchaseAmount(e) {
			this.purchaseAmount = e, this.initAlma()
		}
	}

	customElements.define("w3-alma-widget", s);

	class a extends HTMLElement {
		connectedCallback() {
			this.querySelector("summary")?.addEventListener("click", () => {
				document.querySelectorAll("w3-collapsible-tab").forEach(e => {
					e !== this && e.querySelector("details")?.removeAttribute("open")
				})
			})
		}
	}

	void 0 === customElements.get("w3-collapsible-tab") && customElements.define("w3-collapsible-tab", a);

	/*class r extends HTMLElement {
		constructor() {
			super(), this.bindEvents = this.bindEvents.bind(this), this.toggleBundleState = this.toggleBundleState.bind(this)
		}

		connectedCallback() {
			this.isAddedToForm = !1, this.ProductBundleItem = this, this.variantId = this.ProductBundleItem.dataset.variantId, this.targetForm = document.querySelector(`#${this.ProductBundleItem.dataset.targetFormId}`), this.bundleAdd = this.ProductBundleItem.querySelector(".js-bundle-item-button"), this.targetForm && this.bundleAdd && this.bindEvents()
		}

		bindEvents() {
			this.bundleAdd.addEventListener("click", () => {
				this.toggleBundleState()
			})
		}

		toggleBundleState() {
			let e = this.targetForm.querySelector(`input[value="${this.variantId}"]`);
			this.isAddedToForm ? (this.bundleAdd.classList.toggle("selected"), e.disabled = !0, this.isAddedToForm = !1) : (this.bundleAdd.classList.toggle("selected"), e.disabled = !1, this.isAddedToForm = !0)
		}
	}

	customElements.define("w3-product-bundle-item", r);*/

	class ProductBundleItem extends HTMLElement {
		constructor() {
			super(),
				this.bindEvents = this.bindEvents.bind(this),
				this.toggleBundleState = this.toggleBundleState.bind(this)
		}
		connectedCallback() {
			this.isAddedToForm = !1,
				this.ProductBundleItem = this,
				this.variantId = this.ProductBundleItem.dataset.variantId,
				this.variantPrice = parseInt(this.ProductBundleItem.dataset.variantPrice),
				this.targetForm = document.querySelector(`#${this.ProductBundleItem.dataset.targetFormId}`),
				this.bundleAdd = this.ProductBundleItem.querySelector(".js-bundle-item-button"),
			this.targetForm && this.bundleAdd && this.bindEvents()
		}
		disconnectedCallback() {
			this.unbindEvents()
		}
		bindEvents() {
			this.bundleAdd.addEventListener("click", this.toggleBundleState)
		}
		unbindEvents() {
			this.bundleAdd.removeEventListener("click", this.toggleBundleState)
		}
		toggleBundleState() {
			const formInputs = this.targetForm.querySelectorAll(`.cross-sell-${this.variantId}`);
			const formInputsPreorder = this.targetForm.querySelectorAll(`.cross-sell-preorder-${this.variantId}`);
			this.bundleAdd.classList.toggle("selected");

			if (this.isAddedToForm) {
				formInputs.forEach(formInput => {
					formInput.disabled = true;
				});
				formInputsPreorder.forEach(formInput => {
					formInput.disabled = true;
				});
				this.isAddedToForm = false;
			} else {
				formInputs.forEach(formInput => {
					formInput.disabled = false;
				});
				if (this.bundleAdd.classList.contains("preorder")) {
					formInputsPreorder.forEach(formInput => {
						formInput.disabled = false;
					});
				}
				this.isAddedToForm = true;
			}
			// this.updateProductPrice();
		}
		updateProductPrice() {
			if (this.productPriceEl = this.targetForm.querySelector(".js-total-product-price"),
				this.productTotalPrice = parseInt(this.productPriceEl.dataset.totalPrice),
				this.isAddedToForm) {
				const price1 = parseInt(this.productTotalPrice) + parseInt(this.variantPrice);
				this.productPriceEl.dataset.totalPrice = price1,
					this.productPriceEl.innerHTML = Shopify.formatMoney(price1, Shopify.moneyFormat)
			} else {
				const price = parseInt(this.productTotalPrice) - parseInt(this.variantPrice);
				this.productPriceEl.dataset.totalPrice = price,
					this.productPriceEl.innerHTML = Shopify.formatMoney(price, Shopify.moneyFormat)
			}
		}
	}
	customElements.define("w3-product-bundle-item", ProductBundleItem);



	let l = "collection_couleur:", n = async ({sectionId: e, collectionColor: t, multipleCollectionColor: i}) => {
		e || console.log("section_id is required");
		let s = `/search?resources[type]=product&section_id=${e}`;
		t && (s += `&q=${l}${t}`), i && (i = i.map(e => `${l}${e}`).join(" OR "), s += `&q=${i}`);
		let a = await fetch(s, {cache: "force-cache"});
		return await a.text()
	};

	class o extends HTMLElement {
		constructor() {
			super(), this.collectionColor = this.getAttribute("collection-color"), this.currentProductHandle = this.getAttribute("current-product-handle")
		}

		connectedCallback() {
			this.collectionColor || console.log("Attribute collection-color is required"), this.appendColors().then(e => console.log(e))
		}

		async appendColors() {
			let e = await n({collectionColor: this.collectionColor, sectionId: "product-colors"}),
				t = new DOMParser().parseFromString(e, "text/html"),
				i = (t = t.querySelector(".shopify-section")).querySelector(`[data-handle="${this.currentProductHandle}"] .product-color-swatch`);
			if (i) {
				let e = i.closest(".product-color-swatch-link").querySelector("input");
				e?.setAttribute("checked", "checked"), e?.classList.add("product-variant-option--selected")
			}
			this.innerHTML = t.outerHTML
		}
	}

	customElements.define("w3-product-colors", o);

	class d extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.ProductQuantity = this, this.minusButton = this.ProductQuantity.querySelector(".js-quantity-minus"), this.plusButton = this.ProductQuantity.querySelector(".js-quantity-plus"), this.input = this.ProductQuantity.querySelector("input"), this.bindEvents()
		}

		bindEvents() {
			this.minusButton.addEventListener("click", () => {
				this.decreaseQuantity()
			}), this.plusButton.addEventListener("click", () => {
				this.increaseQuantity()
			})
		}

		decreaseQuantity() {
			let e = parseInt(this.input.value);
			e > 1 && (this.input.value = e - 1), this.updateButtonState()
		}

		increaseQuantity() {
			let e = parseInt(this.input.value);
			e < parseInt(this.input.dataset.maxQuantity) && (this.input.value = e + 1), this.updateButtonState()
		}

		updateButtonState() {
			let e = parseInt(this.input.value), t = parseInt(this.input.dataset.maxQuantity);
			1 === e ? this.minusButton.setAttribute("disabled", !0) : this.minusButton.removeAttribute("disabled"), e === t ? this.plusButton.setAttribute("disabled", !0) : this.plusButton.removeAttribute("disabled")
		}
	}

	void 0 === customElements.get("product-quantity") && customElements.define("product-quantity", d);

	class p extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			fetch(this.dataset.url).then(e => e.text()).then(e => {
				let t = document.createElement("div");
				t.innerHTML = e;
				let i = t.querySelector("product-recommendations");
				i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML, window.lozadObserver?.observe())
			}).catch(e => {
				console.error(e)
			})
		}
	}

	function c(e) {
		return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object
	}

	function u(e, t) {
		void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach(i => {
			void 0 === e[i] ? e[i] = t[i] : c(t[i]) && c(e[i]) && Object.keys(t[i]).length > 0 && u(e[i], t[i])
		})
	}

	customElements.define("product-recommendations", p);
	let h = {
		body: {},
		addEventListener() {
		},
		removeEventListener() {
		},
		activeElement: {
			blur() {
			}, nodeName: ""
		},
		querySelector: () => null,
		querySelectorAll: () => [],
		getElementById: () => null,
		createEvent: () => ({
			initEvent() {
			}
		}),
		createElement: () => ({
			children: [], childNodes: [], style: {}, setAttribute() {
			}, getElementsByTagName: () => []
		}),
		createElementNS: () => ({}),
		importNode: () => null,
		location: {hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: ""}
	};

	function m() {
		let e = "undefined" != typeof document ? document : {};
		return u(e, h), e
	}

	let f = {
		document: h,
		navigator: {userAgent: ""},
		location: {hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: ""},
		history: {
			replaceState() {
			}, pushState() {
			}, go() {
			}, back() {
			}
		},
		CustomEvent: function () {
			return this
		},
		addEventListener() {
		},
		removeEventListener() {
		},
		getComputedStyle: () => ({getPropertyValue: () => ""}),
		Image() {
		},
		Date() {
		},
		screen: {},
		setTimeout() {
		},
		clearTimeout() {
		},
		matchMedia: () => ({}),
		requestAnimationFrame: e => "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
		cancelAnimationFrame(e) {
			"undefined" != typeof setTimeout && clearTimeout(e)
		}
	};

	function g() {
		let e = "undefined" != typeof window ? window : {};
		return u(e, f), e
	}

	function v(e, t) {
		return void 0 === t && (t = 0), setTimeout(e, t)
	}

	function b() {
		return Date.now()
	}

	function w(e) {
		return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1)
	}

	function S() {
		let e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ["__proto__", "constructor", "prototype"];
		for (let i = 1; i < arguments.length; i += 1) {
			let s = i < 0 || arguments.length <= i ? void 0 : arguments[i];
			if (null != s && ("undefined" != typeof window && void 0 !== window.HTMLElement ? !(s instanceof HTMLElement) : !s || 1 !== s.nodeType && 11 !== s.nodeType)) {
				let i = Object.keys(Object(s)).filter(e => 0 > t.indexOf(e));
				for (let t = 0, a = i.length; t < a; t += 1) {
					let a = i[t], r = Object.getOwnPropertyDescriptor(s, a);
					void 0 !== r && r.enumerable && (w(e[a]) && w(s[a]) ? s[a].__swiper__ ? e[a] = s[a] : S(e[a], s[a]) : !w(e[a]) && w(s[a]) ? (e[a] = {}, s[a].__swiper__ ? e[a] = s[a] : S(e[a], s[a])) : e[a] = s[a])
				}
			}
		}
		return e
	}

	function y(e, t, i) {
		e.style.setProperty(t, i)
	}

	function E(e) {
		let t, {swiper: i, targetPosition: s, side: a} = e, r = g(), l = -i.translate, n = null, o = i.params.speed;
		i.wrapperEl.style.scrollSnapType = "none", r.cancelAnimationFrame(i.cssModeFrameID);
		let d = s > l ? "next" : "prev", p = (e, t) => "next" === d && e >= t || "prev" === d && e <= t, c = () => {
			t = new Date().getTime(), null === n && (n = t);
			let e = l + (.5 - Math.cos(Math.max(Math.min((t - n) / o, 1), 0) * Math.PI) / 2) * (s - l);
			if (p(e, s) && (e = s), i.wrapperEl.scrollTo({[a]: e}), p(e, s)) {
				i.wrapperEl.style.overflow = "hidden", i.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
					i.wrapperEl.style.overflow = "", i.wrapperEl.scrollTo({[a]: e})
				}), r.cancelAnimationFrame(i.cssModeFrameID);
				return
			}
			i.cssModeFrameID = r.requestAnimationFrame(c)
		};
		c()
	}

	function T(e) {
		return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e
	}

	function x(e, t) {
		return void 0 === t && (t = ""), [...e.children].filter(e => e.matches(t))
	}

	function C(e) {
		try {
			console.warn(e);
			return
		} catch (e) {
		}
	}

	function M(e, t) {
		var i;
		void 0 === t && (t = []);
		let s = document.createElement(e);
		return s.classList.add(...Array.isArray(t) ? t : (void 0 === (i = t) && (i = ""), i.trim().split(" ").filter(e => !!e.trim()))), s
	}

	function P(e, t) {
		return g().getComputedStyle(e, null).getPropertyValue(t)
	}

	function L(e) {
		let t, i = e;
		if (i) {
			for (t = 0; null !== (i = i.previousSibling);) 1 === i.nodeType && (t += 1);
			return t
		}
	}

	function A(e, t) {
		let i = [], s = e.parentElement;
		for (; s;) t ? s.matches(t) && i.push(s) : i.push(s), s = s.parentElement;
		return i
	}

	function k(e, t, i) {
		let s = g();
		return i ? e["width" === t ? "offsetWidth" : "offsetHeight"] + parseFloat(s.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-right" : "margin-top")) + parseFloat(s.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-left" : "margin-bottom")) : e.offsetWidth
	}

	function I() {
		return e || (e = function () {
			let e = g(), t = m();
			return {
				smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
				touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
			}
		}()), e
	}

	let O = (e, t) => {
		if (!e || e.destroyed || !e.params) return;
		let i = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
		if (i) {
			let t = i.querySelector(`.${e.params.lazyPreloaderClass}`);
			!t && e.isElement && (i.shadowRoot ? t = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
				i.shadowRoot && (t = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`)) && t.remove()
			})), t && t.remove()
		}
	}, z = (e, t) => {
		if (!e.slides[t]) return;
		let i = e.slides[t].querySelector('[loading="lazy"]');
		i && i.removeAttribute("loading")
	}, D = e => {
		if (!e || e.destroyed || !e.params) return;
		let t = e.params.lazyPreloadPrevNext, i = e.slides.length;
		if (!i || !t || t < 0) return;
		t = Math.min(t, i);
		let s = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView),
			a = e.activeIndex;
		if (e.params.grid && e.params.grid.rows > 1) {
			let i = [a - t];
			i.push(...Array.from({length: t}).map((e, t) => a + s + t)), e.slides.forEach((t, s) => {
				i.includes(t.column) && z(e, s)
			});
			return
		}
		let r = a + s - 1;
		if (e.params.rewind || e.params.loop) for (let s = a - t; s <= r + t; s += 1) {
			let t = (s % i + i) % i;
			(t < a || t > r) && z(e, t)
		} else for (let s = Math.max(a - t, 0); s <= Math.min(r + t, i - 1); s += 1) s !== a && (s > r || s < a) && z(e, s)
	};

	function G(e) {
		let {swiper: t, runCallbacks: i, direction: s, step: a} = e, {activeIndex: r, previousIndex: l} = t, n = s;
		if (n || (n = r > l ? "next" : r < l ? "prev" : "reset"), t.emit(`transition${a}`), i && r !== l) {
			if ("reset" === n) {
				t.emit(`slideResetTransition${a}`);
				return
			}
			t.emit(`slideChangeTransition${a}`), "next" === n ? t.emit(`slideNextTransition${a}`) : t.emit(`slidePrevTransition${a}`)
		}
	}

	function $(e, t, i) {
		let s = g(), {params: a} = e, r = a.edgeSwipeDetection, l = a.edgeSwipeThreshold;
		return !r || !(i <= l) && !(i >= s.innerWidth - l) || "prevent" === r && (t.preventDefault(), !0)
	}

	function B(e) {
		let t = m(), i = e;
		i.originalEvent && (i = i.originalEvent);
		let s = this.touchEventsData;
		if ("pointerdown" === i.type) {
			if (null !== s.pointerId && s.pointerId !== i.pointerId) return;
			s.pointerId = i.pointerId
		} else "touchstart" === i.type && 1 === i.targetTouches.length && (s.touchId = i.targetTouches[0].identifier);
		if ("touchstart" === i.type) {
			$(this, i, i.targetTouches[0].pageX);
			return
		}
		let {params: a, touches: r, enabled: l} = this;
		if (!l || !a.simulateTouch && "mouse" === i.pointerType || this.animating && a.preventInteractionOnTransition) return;
		!this.animating && a.cssMode && a.loop && this.loopFix();
		let n = i.target;
		if ("wrapper" === a.touchEventsTarget && !this.wrapperEl.contains(n) || "which" in i && 3 === i.which || "button" in i && i.button > 0 || s.isTouched && s.isMoved) return;
		let o = !!a.noSwipingClass && "" !== a.noSwipingClass, d = i.composedPath ? i.composedPath() : i.path;
		o && i.target && i.target.shadowRoot && d && (n = d[0]);
		let p = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`,
			c = !!(i.target && i.target.shadowRoot);
		if (a.noSwiping && (c ? function (e, t) {
			return void 0 === t && (t = this), function t(i) {
				if (!i || i === m() || i === g()) return null;
				i.assignedSlot && (i = i.assignedSlot);
				let s = i.closest(e);
				return s || i.getRootNode ? s || t(i.getRootNode().host) : null
			}(t)
		}(p, n) : n.closest(p))) {
			this.allowClick = !0;
			return
		}
		if (a.swipeHandler && !n.closest(a.swipeHandler)) return;
		r.currentX = i.pageX, r.currentY = i.pageY;
		let u = r.currentX, h = r.currentY;
		if (!$(this, i, u)) return;
		Object.assign(s, {
			isTouched: !0,
			isMoved: !1,
			allowTouchCallbacks: !0,
			isScrolling: void 0,
			startMoving: void 0
		}), r.startX = u, r.startY = h, s.touchStartTime = b(), this.allowClick = !0, this.updateSize(), this.swipeDirection = void 0, a.threshold > 0 && (s.allowThresholdMove = !1);
		let f = !0;
		n.matches(s.focusableElements) && (f = !1, "SELECT" === n.nodeName && (s.isTouched = !1)), t.activeElement && t.activeElement.matches(s.focusableElements) && t.activeElement !== n && t.activeElement.blur();
		let v = f && this.allowTouchMove && a.touchStartPreventDefault;
		(a.touchStartForcePreventDefault || v) && !n.isContentEditable && i.preventDefault(), a.freeMode && a.freeMode.enabled && this.freeMode && this.animating && !a.cssMode && this.freeMode.onTouchStart(), this.emit("touchStart", i)
	}

	function F(e) {
		let t, i;
		let s = m(), a = this.touchEventsData, {params: r, touches: l, rtlTranslate: n, enabled: o} = this;
		if (!o || !r.simulateTouch && "mouse" === e.pointerType) return;
		let d = e;
		if (d.originalEvent && (d = d.originalEvent), "pointermove" === d.type && (null !== a.touchId || d.pointerId !== a.pointerId)) return;
		if ("touchmove" === d.type) {
			if (!(t = [...d.changedTouches].filter(e => e.identifier === a.touchId)[0]) || t.identifier !== a.touchId) return
		} else t = d;
		if (!a.isTouched) {
			a.startMoving && a.isScrolling && this.emit("touchMoveOpposite", d);
			return
		}
		let p = t.pageX, c = t.pageY;
		if (d.preventedByNestedSwiper) {
			l.startX = p, l.startY = c;
			return
		}
		if (!this.allowTouchMove) {
			d.target.matches(a.focusableElements) || (this.allowClick = !1), a.isTouched && (Object.assign(l, {
				startX: p,
				startY: c,
				currentX: p,
				currentY: c
			}), a.touchStartTime = b());
			return
		}
		if (r.touchReleaseOnEdges && !r.loop) {
			if (this.isVertical()) {
				if (c < l.startY && this.translate <= this.maxTranslate() || c > l.startY && this.translate >= this.minTranslate()) {
					a.isTouched = !1, a.isMoved = !1;
					return
				}
			} else if (p < l.startX && this.translate <= this.maxTranslate() || p > l.startX && this.translate >= this.minTranslate()) return
		}
		if (s.activeElement && d.target === s.activeElement && d.target.matches(a.focusableElements)) {
			a.isMoved = !0, this.allowClick = !1;
			return
		}
		a.allowTouchCallbacks && this.emit("touchMove", d), l.previousX = l.currentX, l.previousY = l.currentY, l.currentX = p, l.currentY = c;
		let u = l.currentX - l.startX, h = l.currentY - l.startY;
		if (this.params.threshold && Math.sqrt(u ** 2 + h ** 2) < this.params.threshold) return;
		if (void 0 === a.isScrolling) {
			let e;
			this.isHorizontal() && l.currentY === l.startY || this.isVertical() && l.currentX === l.startX ? a.isScrolling = !1 : u * u + h * h >= 25 && (e = 180 * Math.atan2(Math.abs(h), Math.abs(u)) / Math.PI, a.isScrolling = this.isHorizontal() ? e > r.touchAngle : 90 - e > r.touchAngle)
		}
		if (a.isScrolling && this.emit("touchMoveOpposite", d), void 0 === a.startMoving && (l.currentX !== l.startX || l.currentY !== l.startY) && (a.startMoving = !0), a.isScrolling) {
			a.isTouched = !1;
			return
		}
		if (!a.startMoving) return;
		this.allowClick = !1, !r.cssMode && d.cancelable && d.preventDefault(), r.touchMoveStopPropagation && !r.nested && d.stopPropagation();
		let f = this.isHorizontal() ? u : h,
			g = this.isHorizontal() ? l.currentX - l.previousX : l.currentY - l.previousY;
		r.oneWayMovement && (f = Math.abs(f) * (n ? 1 : -1), g = Math.abs(g) * (n ? 1 : -1)), l.diff = f, f *= r.touchRatio, n && (f = -f, g = -g);
		let v = this.touchesDirection;
		this.swipeDirection = f > 0 ? "prev" : "next", this.touchesDirection = g > 0 ? "prev" : "next";
		let w = this.params.loop && !r.cssMode,
			S = "next" === this.touchesDirection && this.allowSlideNext || "prev" === this.touchesDirection && this.allowSlidePrev;
		if (!a.isMoved) {
			if (w && S && this.loopFix({direction: this.swipeDirection}), a.startTranslate = this.getTranslate(), this.setTransition(0), this.animating) {
				let e = new window.CustomEvent("transitionend", {bubbles: !0, cancelable: !0});
				this.wrapperEl.dispatchEvent(e)
			}
			a.allowMomentumBounce = !1, r.grabCursor && (!0 === this.allowSlideNext || !0 === this.allowSlidePrev) && this.setGrabCursor(!0), this.emit("sliderFirstMove", d)
		}
		if (new Date().getTime(), a.isMoved && a.allowThresholdMove && v !== this.touchesDirection && w && S && Math.abs(f) >= 1) {
			Object.assign(l, {
				startX: p,
				startY: c,
				currentX: p,
				currentY: c,
				startTranslate: a.currentTranslate
			}), a.loopSwapReset = !0, a.startTranslate = a.currentTranslate;
			return
		}
		this.emit("sliderMove", d), a.isMoved = !0, a.currentTranslate = f + a.startTranslate;
		let y = !0, E = r.resistanceRatio;
		if (r.touchReleaseOnEdges && (E = 0), f > 0 ? (w && S && !i && a.allowThresholdMove && a.currentTranslate > (r.centeredSlides ? this.minTranslate() - this.slidesSizesGrid[this.activeIndex + 1] : this.minTranslate()) && this.loopFix({
			direction: "prev",
			setTranslate: !0,
			activeSlideIndex: 0
		}), a.currentTranslate > this.minTranslate() && (y = !1, r.resistance && (a.currentTranslate = this.minTranslate() - 1 + (-this.minTranslate() + a.startTranslate + f) ** E))) : f < 0 && (w && S && !i && a.allowThresholdMove && a.currentTranslate < (r.centeredSlides ? this.maxTranslate() + this.slidesSizesGrid[this.slidesSizesGrid.length - 1] : this.maxTranslate()) && this.loopFix({
			direction: "next",
			setTranslate: !0,
			activeSlideIndex: this.slides.length - ("auto" === r.slidesPerView ? this.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10)))
		}), a.currentTranslate < this.maxTranslate() && (y = !1, r.resistance && (a.currentTranslate = this.maxTranslate() + 1 - (this.maxTranslate() - a.startTranslate - f) ** E))), y && (d.preventedByNestedSwiper = !0), !this.allowSlideNext && "next" === this.swipeDirection && a.currentTranslate < a.startTranslate && (a.currentTranslate = a.startTranslate), !this.allowSlidePrev && "prev" === this.swipeDirection && a.currentTranslate > a.startTranslate && (a.currentTranslate = a.startTranslate), this.allowSlidePrev || this.allowSlideNext || (a.currentTranslate = a.startTranslate), r.threshold > 0) {
			if (Math.abs(f) > r.threshold || a.allowThresholdMove) {
				if (!a.allowThresholdMove) {
					a.allowThresholdMove = !0, l.startX = l.currentX, l.startY = l.currentY, a.currentTranslate = a.startTranslate, l.diff = this.isHorizontal() ? l.currentX - l.startX : l.currentY - l.startY;
					return
				}
			} else {
				a.currentTranslate = a.startTranslate;
				return
			}
		}
		r.followFinger && !r.cssMode && ((r.freeMode && r.freeMode.enabled && this.freeMode || r.watchSlidesProgress) && (this.updateActiveIndex(), this.updateSlidesClasses()), r.freeMode && r.freeMode.enabled && this.freeMode && this.freeMode.onTouchMove(), this.updateProgress(a.currentTranslate), this.setTranslate(a.currentTranslate))
	}

	function _(e) {
		let t, i;
		let s = this, a = s.touchEventsData, r = e;
		if (r.originalEvent && (r = r.originalEvent), "touchend" === r.type || "touchcancel" === r.type) {
			if (!(t = [...r.changedTouches].filter(e => e.identifier === a.touchId)[0]) || t.identifier !== a.touchId) return
		} else {
			if (null !== a.touchId || r.pointerId !== a.pointerId) return;
			t = r
		}
		if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(r.type) && !(["pointercancel", "contextmenu"].includes(r.type) && (s.browser.isSafari || s.browser.isWebView))) return;
		a.pointerId = null, a.touchId = null;
		let {params: l, touches: n, rtlTranslate: o, slidesGrid: d, enabled: p} = s;
		if (!p || !l.simulateTouch && "mouse" === r.pointerType) return;
		if (a.allowTouchCallbacks && s.emit("touchEnd", r), a.allowTouchCallbacks = !1, !a.isTouched) {
			a.isMoved && l.grabCursor && s.setGrabCursor(!1), a.isMoved = !1, a.startMoving = !1;
			return
		}
		l.grabCursor && a.isMoved && a.isTouched && (!0 === s.allowSlideNext || !0 === s.allowSlidePrev) && s.setGrabCursor(!1);
		let c = b(), u = c - a.touchStartTime;
		if (s.allowClick) {
			let e = r.path || r.composedPath && r.composedPath();
			s.updateClickedSlide(e && e[0] || r.target, e), s.emit("tap click", r), u < 300 && c - a.lastClickTime < 300 && s.emit("doubleTap doubleClick", r)
		}
		if (a.lastClickTime = b(), v(() => {
			s.destroyed || (s.allowClick = !0)
		}), !a.isTouched || !a.isMoved || !s.swipeDirection || 0 === n.diff && !a.loopSwapReset || a.currentTranslate === a.startTranslate && !a.loopSwapReset) {
			a.isTouched = !1, a.isMoved = !1, a.startMoving = !1;
			return
		}
		if (a.isTouched = !1, a.isMoved = !1, a.startMoving = !1, i = l.followFinger ? o ? s.translate : -s.translate : -a.currentTranslate, l.cssMode) return;
		if (l.freeMode && l.freeMode.enabled) {
			s.freeMode.onTouchEnd({currentPos: i});
			return
		}
		let h = i >= -s.maxTranslate() && !s.params.loop, m = 0, f = s.slidesSizesGrid[0];
		for (let e = 0; e < d.length; e += e < l.slidesPerGroupSkip ? 1 : l.slidesPerGroup) {
			let t = e < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
			void 0 !== d[e + t] ? (h || i >= d[e] && i < d[e + t]) && (m = e, f = d[e + t] - d[e]) : (h || i >= d[e]) && (m = e, f = d[d.length - 1] - d[d.length - 2])
		}
		let g = null, w = null;
		l.rewind && (s.isBeginning ? w = l.virtual && l.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1 : s.isEnd && (g = 0));
		let S = (i - d[m]) / f, y = m < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
		if (u > l.longSwipesMs) {
			if (!l.longSwipes) {
				s.slideTo(s.activeIndex);
				return
			}
			"next" === s.swipeDirection && (S >= l.longSwipesRatio ? s.slideTo(l.rewind && s.isEnd ? g : m + y) : s.slideTo(m)), "prev" === s.swipeDirection && (S > 1 - l.longSwipesRatio ? s.slideTo(m + y) : null !== w && S < 0 && Math.abs(S) > l.longSwipesRatio ? s.slideTo(w) : s.slideTo(m))
		} else {
			if (!l.shortSwipes) {
				s.slideTo(s.activeIndex);
				return
			}
			s.navigation && (r.target === s.navigation.nextEl || r.target === s.navigation.prevEl) ? r.target === s.navigation.nextEl ? s.slideTo(m + y) : s.slideTo(m) : ("next" === s.swipeDirection && s.slideTo(null !== g ? g : m + y), "prev" === s.swipeDirection && s.slideTo(null !== w ? w : m))
		}
	}

	function N() {
		let e = this, {params: t, el: i} = e;
		if (i && 0 === i.offsetWidth) return;
		t.breakpoints && e.setBreakpoint();
		let {allowSlideNext: s, allowSlidePrev: a, snapGrid: r} = e, l = e.virtual && e.params.virtual.enabled;
		e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
		let n = l && t.loop;
		"auto" !== t.slidesPerView && !(t.slidesPerView > 1) || !e.isEnd || e.isBeginning || e.params.centeredSlides || n ? e.params.loop && !l ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0) : e.slideTo(e.slides.length - 1, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
			e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume()
		}, 500)), e.allowSlidePrev = a, e.allowSlideNext = s, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow()
	}

	function V(e) {
		this.enabled && !this.allowClick && (this.params.preventClicks && e.preventDefault(), this.params.preventClicksPropagation && this.animating && (e.stopPropagation(), e.stopImmediatePropagation()))
	}

	function q() {
		let {wrapperEl: e, rtlTranslate: t, enabled: i} = this;
		if (!i) return;
		this.previousTranslate = this.translate, this.isHorizontal() ? this.translate = -e.scrollLeft : this.translate = -e.scrollTop, 0 === this.translate && (this.translate = 0), this.updateActiveIndex(), this.updateSlidesClasses();
		let s = this.maxTranslate() - this.minTranslate();
		(0 === s ? 0 : (this.translate - this.minTranslate()) / s) !== this.progress && this.updateProgress(t ? -this.translate : this.translate), this.emit("setTranslate", this.translate, !1)
	}

	function H(e) {
		O(this, e.target), !this.params.cssMode && ("auto" === this.params.slidesPerView || this.params.autoHeight) && this.update()
	}

	function j() {
		!this.documentTouchHandlerProceeded && (this.documentTouchHandlerProceeded = !0, this.params.touchReleaseOnEdges && (this.el.style.touchAction = "auto"))
	}

	let R = (e, t) => {
		let i = m(), {params: s, el: a, wrapperEl: r, device: l} = e, n = !!s.nested,
			o = "on" === t ? "addEventListener" : "removeEventListener";
		i[o]("touchstart", e.onDocumentTouchStart, {
			passive: !1,
			capture: n
		}), a[o]("touchstart", e.onTouchStart, {passive: !1}), a[o]("pointerdown", e.onTouchStart, {passive: !1}), i[o]("touchmove", e.onTouchMove, {
			passive: !1,
			capture: n
		}), i[o]("pointermove", e.onTouchMove, {
			passive: !1,
			capture: n
		}), i[o]("touchend", e.onTouchEnd, {passive: !0}), i[o]("pointerup", e.onTouchEnd, {passive: !0}), i[o]("pointercancel", e.onTouchEnd, {passive: !0}), i[o]("touchcancel", e.onTouchEnd, {passive: !0}), i[o]("pointerout", e.onTouchEnd, {passive: !0}), i[o]("pointerleave", e.onTouchEnd, {passive: !0}), i[o]("contextmenu", e.onTouchEnd, {passive: !0}), (s.preventClicks || s.preventClicksPropagation) && a[o]("click", e.onClick, !0), s.cssMode && r[o]("scroll", e.onScroll), s.updateOnWindowResize ? e[t](l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", N, !0) : e[t]("observerUpdate", N, !0), a[o]("load", e.onLoad, {capture: !0})
	}, W = (e, t) => e.grid && t.grid && t.grid.rows > 1;
	var Y = {
		init: !0,
		direction: "horizontal",
		oneWayMovement: !1,
		touchEventsTarget: "wrapper",
		initialSlide: 0,
		speed: 300,
		cssMode: !1,
		updateOnWindowResize: !0,
		resizeObserver: !0,
		nested: !1,
		createElements: !1,
		eventsPrefix: "swiper",
		enabled: !0,
		focusableElements: "input, select, option, textarea, button, video, label",
		width: null,
		height: null,
		preventInteractionOnTransition: !1,
		userAgent: null,
		url: null,
		edgeSwipeDetection: !1,
		edgeSwipeThreshold: 20,
		autoHeight: !1,
		setWrapperSize: !1,
		virtualTranslate: !1,
		effect: "slide",
		breakpoints: void 0,
		breakpointsBase: "window",
		spaceBetween: 0,
		slidesPerView: 1,
		slidesPerGroup: 1,
		slidesPerGroupSkip: 0,
		slidesPerGroupAuto: !1,
		centeredSlides: !1,
		centeredSlidesBounds: !1,
		slidesOffsetBefore: 0,
		slidesOffsetAfter: 0,
		normalizeSlideIndex: !0,
		centerInsufficientSlides: !1,
		watchOverflow: !0,
		roundLengths: !1,
		touchRatio: 1,
		touchAngle: 45,
		simulateTouch: !0,
		shortSwipes: !0,
		longSwipes: !0,
		longSwipesRatio: .5,
		longSwipesMs: 300,
		followFinger: !0,
		allowTouchMove: !0,
		threshold: 5,
		touchMoveStopPropagation: !1,
		touchStartPreventDefault: !0,
		touchStartForcePreventDefault: !1,
		touchReleaseOnEdges: !1,
		uniqueNavElements: !0,
		resistance: !0,
		resistanceRatio: .85,
		watchSlidesProgress: !1,
		grabCursor: !1,
		preventClicks: !0,
		preventClicksPropagation: !0,
		slideToClickedSlide: !1,
		loop: !1,
		loopAddBlankSlides: !0,
		loopAdditionalSlides: 0,
		loopPreventsSliding: !0,
		rewind: !1,
		allowSlidePrev: !0,
		allowSlideNext: !0,
		swipeHandler: null,
		noSwiping: !0,
		noSwipingClass: "swiper-no-swiping",
		noSwipingSelector: null,
		passiveListeners: !0,
		maxBackfaceHiddenSlides: 10,
		containerModifierClass: "swiper-",
		slideClass: "swiper-slide",
		slideBlankClass: "swiper-slide-blank",
		slideActiveClass: "swiper-slide-active",
		slideVisibleClass: "swiper-slide-visible",
		slideFullyVisibleClass: "swiper-slide-fully-visible",
		slideNextClass: "swiper-slide-next",
		slidePrevClass: "swiper-slide-prev",
		wrapperClass: "swiper-wrapper",
		lazyPreloaderClass: "swiper-lazy-preloader",
		lazyPreloadPrevNext: 0,
		runCallbacksOnInit: !0,
		_emitClasses: !1
	};
	let X = {
		eventsEmitter: {
			on(e, t, i) {
				let s = this;
				if (!s.eventsListeners || s.destroyed || "function" != typeof t) return s;
				let a = i ? "unshift" : "push";
				return e.split(" ").forEach(e => {
					s.eventsListeners[e] || (s.eventsListeners[e] = []), s.eventsListeners[e][a](t)
				}), s
			}, once(e, t, i) {
				let s = this;
				if (!s.eventsListeners || s.destroyed || "function" != typeof t) return s;

				function a() {
					s.off(e, a), a.__emitterProxy && delete a.__emitterProxy;
					for (var i = arguments.length, r = Array(i), l = 0; l < i; l++) r[l] = arguments[l];
					t.apply(s, r)
				}

				return a.__emitterProxy = t, s.on(e, a, i)
			}, onAny(e, t) {
				return !this.eventsListeners || this.destroyed || "function" != typeof e || 0 > this.eventsAnyListeners.indexOf(e) && this.eventsAnyListeners[t ? "unshift" : "push"](e), this
			}, offAny(e) {
				if (!this.eventsListeners || this.destroyed || !this.eventsAnyListeners) return this;
				let t = this.eventsAnyListeners.indexOf(e);
				return t >= 0 && this.eventsAnyListeners.splice(t, 1), this
			}, off(e, t) {
				let i = this;
				return i.eventsListeners && !i.destroyed && i.eventsListeners && e.split(" ").forEach(e => {
					void 0 === t ? i.eventsListeners[e] = [] : i.eventsListeners[e] && i.eventsListeners[e].forEach((s, a) => {
						(s === t || s.__emitterProxy && s.__emitterProxy === t) && i.eventsListeners[e].splice(a, 1)
					})
				}), i
			}, emit() {
				let e, t, i;
				let s = this;
				if (!s.eventsListeners || s.destroyed || !s.eventsListeners) return s;
				for (var a = arguments.length, r = Array(a), l = 0; l < a; l++) r[l] = arguments[l];
				return "string" == typeof r[0] || Array.isArray(r[0]) ? (e = r[0], t = r.slice(1, r.length), i = s) : (e = r[0].events, t = r[0].data, i = r[0].context || s), t.unshift(i), (Array.isArray(e) ? e : e.split(" ")).forEach(e => {
					s.eventsAnyListeners && s.eventsAnyListeners.length && s.eventsAnyListeners.forEach(s => {
						s.apply(i, [e, ...t])
					}), s.eventsListeners && s.eventsListeners[e] && s.eventsListeners[e].forEach(e => {
						e.apply(i, t)
					})
				}), s
			}
		}, update: {
			updateSize: function () {
				let e, t;
				let i = this.el;
				e = void 0 !== this.params.width && null !== this.params.width ? this.params.width : i.clientWidth, t = void 0 !== this.params.height && null !== this.params.height ? this.params.height : i.clientHeight, 0 === e && this.isHorizontal() || 0 === t && this.isVertical() || (e = e - parseInt(P(i, "padding-left") || 0, 10) - parseInt(P(i, "padding-right") || 0, 10), t = t - parseInt(P(i, "padding-top") || 0, 10) - parseInt(P(i, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(t) && (t = 0), Object.assign(this, {
					width: e,
					height: t,
					size: this.isHorizontal() ? e : t
				}))
			}, updateSlides: function () {
				let e;
				let t = this;

				function i(e, i) {
					return parseFloat(e.getPropertyValue(t.getDirectionLabel(i)) || 0)
				}

				let s = t.params, {wrapperEl: a, slidesEl: r, size: l, rtlTranslate: n, wrongRTL: o} = t,
					d = t.virtual && s.virtual.enabled, p = d ? t.virtual.slides.length : t.slides.length,
					c = x(r, `.${t.params.slideClass}, swiper-slide`), u = d ? t.virtual.slides.length : c.length,
					h = [], m = [], f = [], g = s.slidesOffsetBefore;
				"function" == typeof g && (g = s.slidesOffsetBefore.call(t));
				let v = s.slidesOffsetAfter;
				"function" == typeof v && (v = s.slidesOffsetAfter.call(t));
				let b = t.snapGrid.length, w = t.slidesGrid.length, S = s.spaceBetween, E = -g, T = 0, C = 0;
				if (void 0 === l) return;
				"string" == typeof S && S.indexOf("%") >= 0 ? S = parseFloat(S.replace("%", "")) / 100 * l : "string" == typeof S && (S = parseFloat(S)), t.virtualSize = -S, c.forEach(e => {
					n ? e.style.marginLeft = "" : e.style.marginRight = "", e.style.marginBottom = "", e.style.marginTop = ""
				}), s.centeredSlides && s.cssMode && (y(a, "--swiper-centered-offset-before", ""), y(a, "--swiper-centered-offset-after", ""));
				let M = s.grid && s.grid.rows > 1 && t.grid;
				M ? t.grid.initSlides(c) : t.grid && t.grid.unsetSlides();
				let L = "auto" === s.slidesPerView && s.breakpoints && Object.keys(s.breakpoints).filter(e => void 0 !== s.breakpoints[e].slidesPerView).length > 0;
				for (let a = 0; a < u; a += 1) {
					let r;
					if (e = 0, c[a] && (r = c[a]), M && t.grid.updateSlide(a, r, c), !c[a] || "none" !== P(r, "display")) {
						if ("auto" === s.slidesPerView) {
							L && (c[a].style[t.getDirectionLabel("width")] = "");
							let l = getComputedStyle(r), n = r.style.transform, o = r.style.webkitTransform;
							if (n && (r.style.transform = "none"), o && (r.style.webkitTransform = "none"), s.roundLengths) e = t.isHorizontal() ? k(r, "width", !0) : k(r, "height", !0); else {
								let t = i(l, "width"), s = i(l, "padding-left"), a = i(l, "padding-right"),
									n = i(l, "margin-left"), o = i(l, "margin-right"),
									d = l.getPropertyValue("box-sizing");
								if (d && "border-box" === d) e = t + n + o; else {
									let {clientWidth: i, offsetWidth: l} = r;
									e = t + s + a + n + o + (l - i)
								}
							}
							n && (r.style.transform = n), o && (r.style.webkitTransform = o), s.roundLengths && (e = Math.floor(e))
						} else e = (l - (s.slidesPerView - 1) * S) / s.slidesPerView, s.roundLengths && (e = Math.floor(e)), c[a] && (c[a].style[t.getDirectionLabel("width")] = `${e}px`);
						c[a] && (c[a].swiperSlideSize = e), f.push(e), s.centeredSlides ? (E = E + e / 2 + T / 2 + S, 0 === T && 0 !== a && (E = E - l / 2 - S), 0 === a && (E = E - l / 2 - S), .001 > Math.abs(E) && (E = 0), s.roundLengths && (E = Math.floor(E)), C % s.slidesPerGroup == 0 && h.push(E), m.push(E)) : (s.roundLengths && (E = Math.floor(E)), (C - Math.min(t.params.slidesPerGroupSkip, C)) % t.params.slidesPerGroup == 0 && h.push(E), m.push(E), E = E + e + S), t.virtualSize += e + S, T = e, C += 1
					}
				}
				if (t.virtualSize = Math.max(t.virtualSize, l) + v, n && o && ("slide" === s.effect || "coverflow" === s.effect) && (a.style.width = `${t.virtualSize + S}px`), s.setWrapperSize && (a.style[t.getDirectionLabel("width")] = `${t.virtualSize + S}px`), M && t.grid.updateWrapperSize(e, h), !s.centeredSlides) {
					let e = [];
					for (let i = 0; i < h.length; i += 1) {
						let a = h[i];
						s.roundLengths && (a = Math.floor(a)), h[i] <= t.virtualSize - l && e.push(a)
					}
					h = e, Math.floor(t.virtualSize - l) - Math.floor(h[h.length - 1]) > 1 && h.push(t.virtualSize - l)
				}
				if (d && s.loop) {
					let e = f[0] + S;
					if (s.slidesPerGroup > 1) {
						let i = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / s.slidesPerGroup),
							a = e * s.slidesPerGroup;
						for (let e = 0; e < i; e += 1) h.push(h[h.length - 1] + a)
					}
					for (let i = 0; i < t.virtual.slidesBefore + t.virtual.slidesAfter; i += 1) 1 === s.slidesPerGroup && h.push(h[h.length - 1] + e), m.push(m[m.length - 1] + e), t.virtualSize += e
				}
				if (0 === h.length && (h = [0]), 0 !== S) {
					let e = t.isHorizontal() && n ? "marginLeft" : t.getDirectionLabel("marginRight");
					c.filter((e, t) => !s.cssMode || !!s.loop || t !== c.length - 1).forEach(t => {
						t.style[e] = `${S}px`
					})
				}
				if (s.centeredSlides && s.centeredSlidesBounds) {
					let e = 0;
					f.forEach(t => {
						e += t + (S || 0)
					});
					let t = (e -= S) - l;
					h = h.map(e => e <= 0 ? -g : e > t ? t + v : e)
				}
				if (s.centerInsufficientSlides) {
					let e = 0;
					if (f.forEach(t => {
						e += t + (S || 0)
					}), (e -= S) < l) {
						let t = (l - e) / 2;
						h.forEach((e, i) => {
							h[i] = e - t
						}), m.forEach((e, i) => {
							m[i] = e + t
						})
					}
				}
				if (Object.assign(t, {
					slides: c,
					snapGrid: h,
					slidesGrid: m,
					slidesSizesGrid: f
				}), s.centeredSlides && s.cssMode && !s.centeredSlidesBounds) {
					y(a, "--swiper-centered-offset-before", `${-h[0]}px`), y(a, "--swiper-centered-offset-after", `${t.size / 2 - f[f.length - 1] / 2}px`);
					let e = -t.snapGrid[0], i = -t.slidesGrid[0];
					t.snapGrid = t.snapGrid.map(t => t + e), t.slidesGrid = t.slidesGrid.map(e => e + i)
				}
				if (u !== p && t.emit("slidesLengthChange"), h.length !== b && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), m.length !== w && t.emit("slidesGridLengthChange"), s.watchSlidesProgress && t.updateSlidesOffset(), t.emit("slidesUpdated"), !d && !s.cssMode && ("slide" === s.effect || "fade" === s.effect)) {
					let e = `${s.containerModifierClass}backface-hidden`, i = t.el.classList.contains(e);
					u <= s.maxBackfaceHiddenSlides ? i || t.el.classList.add(e) : i && t.el.classList.remove(e)
				}
			}, updateAutoHeight: function (e) {
				let t;
				let i = this, s = [], a = i.virtual && i.params.virtual.enabled, r = 0;
				"number" == typeof e ? i.setTransition(e) : !0 === e && i.setTransition(i.params.speed);
				let l = e => a ? i.slides[i.getSlideIndexByData(e)] : i.slides[e];
				if ("auto" !== i.params.slidesPerView && i.params.slidesPerView > 1) {
					if (i.params.centeredSlides) (i.visibleSlides || []).forEach(e => {
						s.push(e)
					}); else for (t = 0; t < Math.ceil(i.params.slidesPerView); t += 1) {
						let e = i.activeIndex + t;
						if (e > i.slides.length && !a) break;
						s.push(l(e))
					}
				} else s.push(l(i.activeIndex));
				for (t = 0; t < s.length; t += 1) if (void 0 !== s[t]) {
					let e = s[t].offsetHeight;
					r = e > r ? e : r
				}
				(r || 0 === r) && (i.wrapperEl.style.height = `${r}px`)
			}, updateSlidesOffset: function () {
				let e = this.slides,
					t = this.isElement ? this.isHorizontal() ? this.wrapperEl.offsetLeft : this.wrapperEl.offsetTop : 0;
				for (let i = 0; i < e.length; i += 1) e[i].swiperSlideOffset = (this.isHorizontal() ? e[i].offsetLeft : e[i].offsetTop) - t - this.cssOverflowAdjustment()
			}, updateSlidesProgress: function (e) {
				void 0 === e && (e = this && this.translate || 0);
				let t = this.params, {slides: i, rtlTranslate: s, snapGrid: a} = this;
				if (0 === i.length) return;
				void 0 === i[0].swiperSlideOffset && this.updateSlidesOffset();
				let r = -e;
				s && (r = e), i.forEach(e => {
					e.classList.remove(t.slideVisibleClass, t.slideFullyVisibleClass)
				}), this.visibleSlidesIndexes = [], this.visibleSlides = [];
				let l = t.spaceBetween;
				"string" == typeof l && l.indexOf("%") >= 0 ? l = parseFloat(l.replace("%", "")) / 100 * this.size : "string" == typeof l && (l = parseFloat(l));
				for (let e = 0; e < i.length; e += 1) {
					let n = i[e], o = n.swiperSlideOffset;
					t.cssMode && t.centeredSlides && (o -= i[0].swiperSlideOffset);
					let d = (r + (t.centeredSlides ? this.minTranslate() : 0) - o) / (n.swiperSlideSize + l),
						p = (r - a[0] + (t.centeredSlides ? this.minTranslate() : 0) - o) / (n.swiperSlideSize + l),
						c = -(r - o), u = c + this.slidesSizesGrid[e],
						h = c >= 0 && c <= this.size - this.slidesSizesGrid[e];
					(c >= 0 && c < this.size - 1 || u > 1 && u <= this.size || c <= 0 && u >= this.size) && (this.visibleSlides.push(n), this.visibleSlidesIndexes.push(e), i[e].classList.add(t.slideVisibleClass)), h && i[e].classList.add(t.slideFullyVisibleClass), n.progress = s ? -d : d, n.originalProgress = s ? -p : p
				}
			}, updateProgress: function (e) {
				if (void 0 === e) {
					let t = this.rtlTranslate ? -1 : 1;
					e = this && this.translate && this.translate * t || 0
				}
				let t = this.params, i = this.maxTranslate() - this.minTranslate(), {
					progress: s,
					isBeginning: a,
					isEnd: r,
					progressLoop: l
				} = this, n = a, o = r;
				if (0 === i) s = 0, a = !0, r = !0; else {
					s = (e - this.minTranslate()) / i;
					let t = 1 > Math.abs(e - this.minTranslate()), l = 1 > Math.abs(e - this.maxTranslate());
					a = t || s <= 0, r = l || s >= 1, t && (s = 0), l && (s = 1)
				}
				if (t.loop) {
					let t = this.getSlideIndexByData(0), i = this.getSlideIndexByData(this.slides.length - 1),
						s = this.slidesGrid[t], a = this.slidesGrid[i], r = this.slidesGrid[this.slidesGrid.length - 1],
						n = Math.abs(e);
					(l = n >= s ? (n - s) / r : (n + r - a) / r) > 1 && (l -= 1)
				}
				Object.assign(this, {
					progress: s,
					progressLoop: l,
					isBeginning: a,
					isEnd: r
				}), (t.watchSlidesProgress || t.centeredSlides && t.autoHeight) && this.updateSlidesProgress(e), a && !n && this.emit("reachBeginning toEdge"), r && !o && this.emit("reachEnd toEdge"), (n && !a || o && !r) && this.emit("fromEdge"), this.emit("progress", s)
			}, updateSlidesClasses: function () {
				let e, t, i;
				let {slides: s, params: a, slidesEl: r, activeIndex: l} = this, n = this.virtual && a.virtual.enabled,
					o = this.grid && a.grid && a.grid.rows > 1,
					d = e => x(r, `.${a.slideClass}${e}, swiper-slide${e}`)[0];
				if (s.forEach(e => {
					e.classList.remove(a.slideActiveClass, a.slideNextClass, a.slidePrevClass)
				}), n) {
					if (a.loop) {
						let t = l - this.virtual.slidesBefore;
						t < 0 && (t = this.virtual.slides.length + t), t >= this.virtual.slides.length && (t -= this.virtual.slides.length), e = d(`[data-swiper-slide-index="${t}"]`)
					} else e = d(`[data-swiper-slide-index="${l}"]`)
				} else o ? (e = s.filter(e => e.column === l)[0], i = s.filter(e => e.column === l + 1)[0], t = s.filter(e => e.column === l - 1)[0]) : e = s[l];
				e && (e.classList.add(a.slideActiveClass), o ? i && i.classList.add(a.slideNextClass) : (i = function (e, t) {
					let i = [];
					for (; e.nextElementSibling;) {
						let s = e.nextElementSibling;
						t ? s.matches(t) && i.push(s) : i.push(s), e = s
					}
					return i
				}(e, `.${a.slideClass}, swiper-slide`)[0], a.loop && !i && (i = s[0]), i && i.classList.add(a.slideNextClass), t = function (e, t) {
					let i = [];
					for (; e.previousElementSibling;) {
						let s = e.previousElementSibling;
						t ? s.matches(t) && i.push(s) : i.push(s), e = s
					}
					return i
				}(e, `.${a.slideClass}, swiper-slide`)[0], a.loop), t && t.classList.add(a.slidePrevClass)), this.emitSlidesClasses()
			}, updateActiveIndex: function (e) {
				let t, i;
				let s = this, a = s.rtlTranslate ? s.translate : -s.translate, {
					snapGrid: r,
					params: l,
					activeIndex: n,
					realIndex: o,
					snapIndex: d
				} = s, p = e, c = e => {
					let t = e - s.virtual.slidesBefore;
					return t < 0 && (t = s.virtual.slides.length + t), t >= s.virtual.slides.length && (t -= s.virtual.slides.length), t
				};
				if (void 0 === p && (p = function (e) {
					let t;
					let {slidesGrid: i, params: s} = e, a = e.rtlTranslate ? e.translate : -e.translate;
					for (let e = 0; e < i.length; e += 1) void 0 !== i[e + 1] ? a >= i[e] && a < i[e + 1] - (i[e + 1] - i[e]) / 2 ? t = e : a >= i[e] && a < i[e + 1] && (t = e + 1) : a >= i[e] && (t = e);
					return s.normalizeSlideIndex && (t < 0 || void 0 === t) && (t = 0), t
				}(s)), r.indexOf(a) >= 0) t = r.indexOf(a); else {
					let e = Math.min(l.slidesPerGroupSkip, p);
					t = e + Math.floor((p - e) / l.slidesPerGroup)
				}
				if (t >= r.length && (t = r.length - 1), p === n && !s.params.loop) {
					t !== d && (s.snapIndex = t, s.emit("snapIndexChange"));
					return
				}
				if (p === n && s.params.loop && s.virtual && s.params.virtual.enabled) {
					s.realIndex = c(p);
					return
				}
				let u = s.grid && l.grid && l.grid.rows > 1;
				if (s.virtual && l.virtual.enabled && l.loop) i = c(p); else if (u) {
					let e = s.slides.filter(e => e.column === p)[0],
						t = parseInt(e.getAttribute("data-swiper-slide-index"), 10);
					Number.isNaN(t) && (t = Math.max(s.slides.indexOf(e), 0)), i = Math.floor(t / l.grid.rows)
				} else if (s.slides[p]) {
					let e = s.slides[p].getAttribute("data-swiper-slide-index");
					i = e ? parseInt(e, 10) : p
				} else i = p;
				Object.assign(s, {
					previousSnapIndex: d,
					snapIndex: t,
					previousRealIndex: o,
					realIndex: i,
					previousIndex: n,
					activeIndex: p
				}), s.initialized && D(s), s.emit("activeIndexChange"), s.emit("snapIndexChange"), (s.initialized || s.params.runCallbacksOnInit) && (o !== i && s.emit("realIndexChange"), s.emit("slideChange"))
			}, updateClickedSlide: function (e, t) {
				let i;
				let s = this.params, a = e.closest(`.${s.slideClass}, swiper-slide`);
				!a && this.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach(e => {
					!a && e.matches && e.matches(`.${s.slideClass}, swiper-slide`) && (a = e)
				});
				let r = !1;
				if (a) {
					for (let e = 0; e < this.slides.length; e += 1) if (this.slides[e] === a) {
						r = !0, i = e;
						break
					}
				}
				if (a && r) this.clickedSlide = a, this.virtual && this.params.virtual.enabled ? this.clickedIndex = parseInt(a.getAttribute("data-swiper-slide-index"), 10) : this.clickedIndex = i; else {
					this.clickedSlide = void 0, this.clickedIndex = void 0;
					return
				}
				s.slideToClickedSlide && void 0 !== this.clickedIndex && this.clickedIndex !== this.activeIndex && this.slideToClickedSlide()
			}
		}, translate: {
			getTranslate: function (e) {
				void 0 === e && (e = this.isHorizontal() ? "x" : "y");
				let {params: t, rtlTranslate: i, translate: s, wrapperEl: a} = this;
				if (t.virtualTranslate) return i ? -s : s;
				if (t.cssMode) return s;
				let r = function (e, t) {
					let i, s, a;
					void 0 === t && (t = "x");
					let r = g(), l = function (e) {
						let t;
						let i = g();
						return i.getComputedStyle && (t = i.getComputedStyle(e, null)), !t && e.currentStyle && (t = e.currentStyle), t || (t = e.style), t
					}(e);
					return r.WebKitCSSMatrix ? ((s = l.transform || l.webkitTransform).split(",").length > 6 && (s = s.split(", ").map(e => e.replace(",", ".")).join(", ")), a = new r.WebKitCSSMatrix("none" === s ? "" : s)) : i = (a = l.MozTransform || l.OTransform || l.MsTransform || l.msTransform || l.transform || l.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === t && (s = r.WebKitCSSMatrix ? a.m41 : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])), "y" === t && (s = r.WebKitCSSMatrix ? a.m42 : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])), s || 0
				}(a, e);
				return r += this.cssOverflowAdjustment(), i && (r = -r), r || 0
			}, setTranslate: function (e, t) {
				let {rtlTranslate: i, params: s, wrapperEl: a, progress: r} = this, l = 0, n = 0;
				this.isHorizontal() ? l = i ? -e : e : n = e, s.roundLengths && (l = Math.floor(l), n = Math.floor(n)), this.previousTranslate = this.translate, this.translate = this.isHorizontal() ? l : n, s.cssMode ? a[this.isHorizontal() ? "scrollLeft" : "scrollTop"] = this.isHorizontal() ? -l : -n : s.virtualTranslate || (this.isHorizontal() ? l -= this.cssOverflowAdjustment() : n -= this.cssOverflowAdjustment(), a.style.transform = `translate3d(${l}px, ${n}px, 0px)`);
				let o = this.maxTranslate() - this.minTranslate();
				(0 === o ? 0 : (e - this.minTranslate()) / o) !== r && this.updateProgress(e), this.emit("setTranslate", this.translate, t)
			}, minTranslate: function () {
				return -this.snapGrid[0]
			}, maxTranslate: function () {
				return -this.snapGrid[this.snapGrid.length - 1]
			}, translateTo: function (e, t, i, s, a) {
				let r;
				void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), void 0 === s && (s = !0);
				let l = this, {params: n, wrapperEl: o} = l;
				if (l.animating && n.preventInteractionOnTransition) return !1;
				let d = l.minTranslate(), p = l.maxTranslate();
				if (r = s && e > d ? d : s && e < p ? p : e, l.updateProgress(r), n.cssMode) {
					let e = l.isHorizontal();
					if (0 === t) o[e ? "scrollLeft" : "scrollTop"] = -r; else {
						if (!l.support.smoothScroll) return E({
							swiper: l,
							targetPosition: -r,
							side: e ? "left" : "top"
						}), !0;
						o.scrollTo({[e ? "left" : "top"]: -r, behavior: "smooth"})
					}
					return !0
				}
				return 0 === t ? (l.setTransition(0), l.setTranslate(r), i && (l.emit("beforeTransitionStart", t, a), l.emit("transitionEnd"))) : (l.setTransition(t), l.setTranslate(r), i && (l.emit("beforeTransitionStart", t, a), l.emit("transitionStart")), l.animating || (l.animating = !0, l.onTranslateToWrapperTransitionEnd || (l.onTranslateToWrapperTransitionEnd = function (e) {
					l && !l.destroyed && e.target === this && (l.wrapperEl.removeEventListener("transitionend", l.onTranslateToWrapperTransitionEnd), l.onTranslateToWrapperTransitionEnd = null, delete l.onTranslateToWrapperTransitionEnd, i && l.emit("transitionEnd"))
				}), l.wrapperEl.addEventListener("transitionend", l.onTranslateToWrapperTransitionEnd))), !0
			}
		}, transition: {
			setTransition: function (e, t) {
				this.params.cssMode || (this.wrapperEl.style.transitionDuration = `${e}ms`, this.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : ""), this.emit("setTransition", e, t)
			}, transitionStart: function (e, t) {
				void 0 === e && (e = !0);
				let {params: i} = this;
				i.cssMode || (i.autoHeight && this.updateAutoHeight(), G({
					swiper: this,
					runCallbacks: e,
					direction: t,
					step: "Start"
				}))
			}, transitionEnd: function (e, t) {
				void 0 === e && (e = !0);
				let {params: i} = this;
				this.animating = !1, i.cssMode || (this.setTransition(0), G({
					swiper: this,
					runCallbacks: e,
					direction: t,
					step: "End"
				}))
			}
		}, slide: {
			slideTo: function (e, t, i, s, a) {
				let r;
				void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), "string" == typeof e && (e = parseInt(e, 10));
				let l = this, n = e;
				n < 0 && (n = 0);
				let {
					params: o,
					snapGrid: d,
					slidesGrid: p,
					previousIndex: c,
					activeIndex: u,
					rtlTranslate: h,
					wrapperEl: m,
					enabled: f
				} = l;
				if (l.animating && o.preventInteractionOnTransition || !f && !s && !a) return !1;
				let g = Math.min(l.params.slidesPerGroupSkip, n), v = g + Math.floor((n - g) / l.params.slidesPerGroup);
				v >= d.length && (v = d.length - 1);
				let b = -d[v];
				if (o.normalizeSlideIndex) for (let e = 0; e < p.length; e += 1) {
					let t = -Math.floor(100 * b), i = Math.floor(100 * p[e]), s = Math.floor(100 * p[e + 1]);
					void 0 !== p[e + 1] ? t >= i && t < s - (s - i) / 2 ? n = e : t >= i && t < s && (n = e + 1) : t >= i && (n = e)
				}
				if (l.initialized && n !== u && (!l.allowSlideNext && (h ? b > l.translate && b > l.minTranslate() : b < l.translate && b < l.minTranslate()) || !l.allowSlidePrev && b > l.translate && b > l.maxTranslate() && (u || 0) !== n)) return !1;
				if (n !== (c || 0) && i && l.emit("beforeSlideChangeStart"), l.updateProgress(b), r = n > u ? "next" : n < u ? "prev" : "reset", h && -b === l.translate || !h && b === l.translate) return l.updateActiveIndex(n), o.autoHeight && l.updateAutoHeight(), l.updateSlidesClasses(), "slide" !== o.effect && l.setTranslate(b), "reset" !== r && (l.transitionStart(i, r), l.transitionEnd(i, r)), !1;
				if (o.cssMode) {
					let e = l.isHorizontal(), i = h ? b : -b;
					if (0 === t) {
						let t = l.virtual && l.params.virtual.enabled;
						t && (l.wrapperEl.style.scrollSnapType = "none", l._immediateVirtual = !0), t && !l._cssModeVirtualInitialSet && l.params.initialSlide > 0 ? (l._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
							m[e ? "scrollLeft" : "scrollTop"] = i
						})) : m[e ? "scrollLeft" : "scrollTop"] = i, t && requestAnimationFrame(() => {
							l.wrapperEl.style.scrollSnapType = "", l._immediateVirtual = !1
						})
					} else {
						if (!l.support.smoothScroll) return E({
							swiper: l,
							targetPosition: i,
							side: e ? "left" : "top"
						}), !0;
						m.scrollTo({[e ? "left" : "top"]: i, behavior: "smooth"})
					}
					return !0
				}
				return l.setTransition(t), l.setTranslate(b), l.updateActiveIndex(n), l.updateSlidesClasses(), l.emit("beforeTransitionStart", t, s), l.transitionStart(i, r), 0 === t ? l.transitionEnd(i, r) : l.animating || (l.animating = !0, l.onSlideToWrapperTransitionEnd || (l.onSlideToWrapperTransitionEnd = function (e) {
					l && !l.destroyed && e.target === this && (l.wrapperEl.removeEventListener("transitionend", l.onSlideToWrapperTransitionEnd), l.onSlideToWrapperTransitionEnd = null, delete l.onSlideToWrapperTransitionEnd, l.transitionEnd(i, r))
				}), l.wrapperEl.addEventListener("transitionend", l.onSlideToWrapperTransitionEnd)), !0
			}, slideToLoop: function (e, t, i, s) {
				void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), "string" == typeof e && (e = parseInt(e, 10));
				let a = this, r = a.grid && a.params.grid && a.params.grid.rows > 1, l = e;
				if (a.params.loop) {
					if (a.virtual && a.params.virtual.enabled) l += a.virtual.slidesBefore; else {
						let e;
						if (r) {
							let t = l * a.params.grid.rows;
							e = a.slides.filter(e => 1 * e.getAttribute("data-swiper-slide-index") === t)[0].column
						} else e = a.getSlideIndexByData(l);
						let t = r ? Math.ceil(a.slides.length / a.params.grid.rows) : a.slides.length, {centeredSlides: i} = a.params,
							s = a.params.slidesPerView;
						"auto" === s ? s = a.slidesPerViewDynamic() : (s = Math.ceil(parseFloat(a.params.slidesPerView, 10)), i && s % 2 == 0 && (s += 1));
						let n = t - e < s;
						if (i && (n = n || e < Math.ceil(s / 2)), n) {
							let s = i ? e < a.activeIndex ? "prev" : "next" : e - a.activeIndex - 1 < a.params.slidesPerView ? "next" : "prev";
							a.loopFix({
								direction: s,
								slideTo: !0,
								activeSlideIndex: "next" === s ? e + 1 : e - t + 1,
								slideRealIndex: "next" === s ? a.realIndex : void 0
							})
						}
						if (r) {
							let e = l * a.params.grid.rows;
							l = a.slides.filter(t => 1 * t.getAttribute("data-swiper-slide-index") === e)[0].column
						} else l = a.getSlideIndexByData(l)
					}
				}
				return requestAnimationFrame(() => {
					a.slideTo(l, t, i, s)
				}), a
			}, slideNext: function (e, t, i) {
				void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
				let s = this, {enabled: a, params: r, animating: l} = s;
				if (!a) return s;
				let n = r.slidesPerGroup;
				"auto" === r.slidesPerView && 1 === r.slidesPerGroup && r.slidesPerGroupAuto && (n = Math.max(s.slidesPerViewDynamic("current", !0), 1));
				let o = s.activeIndex < r.slidesPerGroupSkip ? 1 : n, d = s.virtual && r.virtual.enabled;
				if (r.loop) {
					if (l && !d && r.loopPreventsSliding) return !1;
					if (s.loopFix({direction: "next"}), s._clientLeft = s.wrapperEl.clientLeft, s.activeIndex === s.slides.length - 1 && r.cssMode) return requestAnimationFrame(() => {
						s.slideTo(s.activeIndex + o, e, t, i)
					}), !0
				}
				return r.rewind && s.isEnd ? s.slideTo(0, e, t, i) : s.slideTo(s.activeIndex + o, e, t, i)
			}, slidePrev: function (e, t, i) {
				void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
				let s = this, {params: a, snapGrid: r, slidesGrid: l, rtlTranslate: n, enabled: o, animating: d} = s;
				if (!o) return s;
				let p = s.virtual && a.virtual.enabled;
				if (a.loop) {
					if (d && !p && a.loopPreventsSliding) return !1;
					s.loopFix({direction: "prev"}), s._clientLeft = s.wrapperEl.clientLeft
				}

				function c(e) {
					return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
				}

				let u = c(n ? s.translate : -s.translate), h = r.map(e => c(e)), m = r[h.indexOf(u) - 1];
				if (void 0 === m && a.cssMode) {
					let e;
					r.forEach((t, i) => {
						u >= t && (e = i)
					}), void 0 !== e && (m = r[e > 0 ? e - 1 : e])
				}
				let f = 0;
				if (void 0 !== m && ((f = l.indexOf(m)) < 0 && (f = s.activeIndex - 1), "auto" === a.slidesPerView && 1 === a.slidesPerGroup && a.slidesPerGroupAuto && (f = Math.max(f = f - s.slidesPerViewDynamic("previous", !0) + 1, 0))), a.rewind && s.isBeginning) {
					let a = s.params.virtual && s.params.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1;
					return s.slideTo(a, e, t, i)
				}
				return a.loop && 0 === s.activeIndex && a.cssMode ? (requestAnimationFrame(() => {
					s.slideTo(f, e, t, i)
				}), !0) : s.slideTo(f, e, t, i)
			}, slideReset: function (e, t, i) {
				return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, i)
			}, slideToClosest: function (e, t, i, s) {
				void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === s && (s = .5);
				let a = this.activeIndex, r = Math.min(this.params.slidesPerGroupSkip, a),
					l = r + Math.floor((a - r) / this.params.slidesPerGroup),
					n = this.rtlTranslate ? this.translate : -this.translate;
				if (n >= this.snapGrid[l]) {
					let e = this.snapGrid[l];
					n - e > (this.snapGrid[l + 1] - e) * s && (a += this.params.slidesPerGroup)
				} else {
					let e = this.snapGrid[l - 1];
					n - e <= (this.snapGrid[l] - e) * s && (a -= this.params.slidesPerGroup)
				}
				return a = Math.min(a = Math.max(a, 0), this.slidesGrid.length - 1), this.slideTo(a, e, t, i)
			}, slideToClickedSlide: function () {
				let e;
				let t = this, {params: i, slidesEl: s} = t,
					a = "auto" === i.slidesPerView ? t.slidesPerViewDynamic() : i.slidesPerView, r = t.clickedIndex,
					l = t.isElement ? "swiper-slide" : `.${i.slideClass}`;
				if (i.loop) {
					if (t.animating) return;
					e = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), i.centeredSlides ? r < t.loopedSlides - a / 2 || r > t.slides.length - t.loopedSlides + a / 2 ? (t.loopFix(), r = t.getSlideIndex(x(s, `${l}[data-swiper-slide-index="${e}"]`)[0]), v(() => {
						t.slideTo(r)
					})) : t.slideTo(r) : r > t.slides.length - a ? (t.loopFix(), r = t.getSlideIndex(x(s, `${l}[data-swiper-slide-index="${e}"]`)[0]), v(() => {
						t.slideTo(r)
					})) : t.slideTo(r)
				} else t.slideTo(r)
			}
		}, loop: {
			loopCreate: function (e) {
				let t = this, {params: i, slidesEl: s} = t;
				if (!i.loop || t.virtual && t.params.virtual.enabled) return;
				let a = t.grid && i.grid && i.grid.rows > 1, r = i.slidesPerGroup * (a ? i.grid.rows : 1),
					l = t.slides.length % r != 0, n = a && t.slides.length % i.grid.rows != 0, o = e => {
						for (let s = 0; s < e; s += 1) {
							let e = t.isElement ? M("swiper-slide", [i.slideBlankClass]) : M("div", [i.slideClass, i.slideBlankClass]);
							t.slidesEl.append(e)
						}
					};
				l ? i.loopAddBlankSlides ? (o(r - t.slides.length % r), t.recalcSlides(), t.updateSlides()) : C("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)") : n && (i.loopAddBlankSlides ? (o(i.grid.rows - t.slides.length % i.grid.rows), t.recalcSlides(), t.updateSlides()) : C("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)")), x(s, `.${i.slideClass}, swiper-slide`).forEach((e, t) => {
					e.setAttribute("data-swiper-slide-index", t)
				}), t.loopFix({slideRealIndex: e, direction: i.centeredSlides ? void 0 : "next"})
			}, loopFix: function (e) {
				let {
					slideRealIndex: t,
					slideTo: i = !0,
					direction: s,
					setTranslate: a,
					activeSlideIndex: r,
					byController: l,
					byMousewheel: n
				} = void 0 === e ? {} : e, o = this;
				if (!o.params.loop) return;
				o.emit("beforeLoopFix");
				let {
					slides: d,
					allowSlidePrev: p,
					allowSlideNext: c,
					slidesEl: u,
					params: h
				} = o, {centeredSlides: m} = h;
				if (o.allowSlidePrev = !0, o.allowSlideNext = !0, o.virtual && h.virtual.enabled) {
					i && (h.centeredSlides || 0 !== o.snapIndex ? h.centeredSlides && o.snapIndex < h.slidesPerView ? o.slideTo(o.virtual.slides.length + o.snapIndex, 0, !1, !0) : o.snapIndex === o.snapGrid.length - 1 && o.slideTo(o.virtual.slidesBefore, 0, !1, !0) : o.slideTo(o.virtual.slides.length, 0, !1, !0)), o.allowSlidePrev = p, o.allowSlideNext = c, o.emit("loopFix");
					return
				}
				let f = h.slidesPerView;
				"auto" === f ? f = o.slidesPerViewDynamic() : (f = Math.ceil(parseFloat(h.slidesPerView, 10)), m && f % 2 == 0 && (f += 1));
				let g = h.slidesPerGroupAuto ? f : h.slidesPerGroup, v = g;
				v % g != 0 && (v += g - v % g), v += h.loopAdditionalSlides, o.loopedSlides = v;
				let b = o.grid && h.grid && h.grid.rows > 1;
				d.length < f + v ? C("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : b && "row" === h.grid.fill && C("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
				let w = [], S = [], y = o.activeIndex;
				void 0 === r ? r = o.getSlideIndex(d.filter(e => e.classList.contains(h.slideActiveClass))[0]) : y = r;
				let E = "next" === s || !s, T = "prev" === s || !s, x = 0, M = 0,
					P = b ? Math.ceil(d.length / h.grid.rows) : d.length,
					L = (b ? d[r].column : r) + (m && void 0 === a ? -f / 2 + .5 : 0);
				if (L < v) {
					x = Math.max(v - L, g);
					for (let e = 0; e < v - L; e += 1) {
						let t = e - Math.floor(e / P) * P;
						if (b) {
							let e = P - t - 1;
							for (let t = d.length - 1; t >= 0; t -= 1) d[t].column === e && w.push(t)
						} else w.push(P - t - 1)
					}
				} else if (L + f > P - v) {
					M = Math.max(L - (P - 2 * v), g);
					for (let e = 0; e < M; e += 1) {
						let t = e - Math.floor(e / P) * P;
						b ? d.forEach((e, i) => {
							e.column === t && S.push(i)
						}) : S.push(t)
					}
				}
				if (o.__preventObserver__ = !0, requestAnimationFrame(() => {
					o.__preventObserver__ = !1
				}), T && w.forEach(e => {
					d[e].swiperLoopMoveDOM = !0, u.prepend(d[e]), d[e].swiperLoopMoveDOM = !1
				}), E && S.forEach(e => {
					d[e].swiperLoopMoveDOM = !0, u.append(d[e]), d[e].swiperLoopMoveDOM = !1
				}), o.recalcSlides(), "auto" === h.slidesPerView ? o.updateSlides() : b && (w.length > 0 && T || S.length > 0 && E) && o.slides.forEach((e, t) => {
					o.grid.updateSlide(t, e, o.slides)
				}), h.watchSlidesProgress && o.updateSlidesOffset(), i) {
					if (w.length > 0 && T) {
						if (void 0 === t) {
							let e = o.slidesGrid[y], t = o.slidesGrid[y + x] - e;
							n ? o.setTranslate(o.translate - t) : (o.slideTo(y + x, 0, !1, !0), a && (o.touchEventsData.startTranslate = o.touchEventsData.startTranslate - t, o.touchEventsData.currentTranslate = o.touchEventsData.currentTranslate - t))
						} else if (a) {
							let e = b ? w.length / h.grid.rows : w.length;
							o.slideTo(o.activeIndex + e, 0, !1, !0), o.touchEventsData.currentTranslate = o.translate
						}
					} else if (S.length > 0 && E) {
						if (void 0 === t) {
							let e = o.slidesGrid[y], t = o.slidesGrid[y - M] - e;
							n ? o.setTranslate(o.translate - t) : (o.slideTo(y - M, 0, !1, !0), a && (o.touchEventsData.startTranslate = o.touchEventsData.startTranslate - t, o.touchEventsData.currentTranslate = o.touchEventsData.currentTranslate - t))
						} else {
							let e = b ? S.length / h.grid.rows : S.length;
							o.slideTo(o.activeIndex - e, 0, !1, !0)
						}
					}
				}
				if (o.allowSlidePrev = p, o.allowSlideNext = c, o.controller && o.controller.control && !l) {
					let e = {slideRealIndex: t, direction: s, setTranslate: a, activeSlideIndex: r, byController: !0};
					Array.isArray(o.controller.control) ? o.controller.control.forEach(t => {
						!t.destroyed && t.params.loop && t.loopFix({
							...e,
							slideTo: t.params.slidesPerView === h.slidesPerView && i
						})
					}) : o.controller.control instanceof o.constructor && o.controller.control.params.loop && o.controller.control.loopFix({
						...e,
						slideTo: o.controller.control.params.slidesPerView === h.slidesPerView && i
					})
				}
				o.emit("loopFix")
			}, loopDestroy: function () {
				let {params: e, slidesEl: t} = this;
				if (!e.loop || this.virtual && this.params.virtual.enabled) return;
				this.recalcSlides();
				let i = [];
				this.slides.forEach(e => {
					i[void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex] = e
				}), this.slides.forEach(e => {
					e.removeAttribute("data-swiper-slide-index")
				}), i.forEach(e => {
					t.append(e)
				}), this.recalcSlides(), this.slideTo(this.realIndex, 0)
			}
		}, grabCursor: {
			setGrabCursor: function (e) {
				let t = this;
				if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
				let i = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
				t.isElement && (t.__preventObserver__ = !0), i.style.cursor = "move", i.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
					t.__preventObserver__ = !1
				})
			}, unsetGrabCursor: function () {
				let e = this;
				e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
					e.__preventObserver__ = !1
				}))
			}
		}, events: {
			attachEvents: function () {
				let {params: e} = this;
				this.onTouchStart = B.bind(this), this.onTouchMove = F.bind(this), this.onTouchEnd = _.bind(this), this.onDocumentTouchStart = j.bind(this), e.cssMode && (this.onScroll = q.bind(this)), this.onClick = V.bind(this), this.onLoad = H.bind(this), R(this, "on")
			}, detachEvents: function () {
				R(this, "off")
			}
		}, breakpoints: {
			setBreakpoint: function () {
				let e = this, {realIndex: t, initialized: i, params: s, el: a} = e, r = s.breakpoints;
				if (!r || r && 0 === Object.keys(r).length) return;
				let l = e.getBreakpoint(r, e.params.breakpointsBase, e.el);
				if (!l || e.currentBreakpoint === l) return;
				let n = (l in r ? r[l] : void 0) || e.originalParams, o = W(e, s), d = W(e, n), p = s.enabled;
				o && !d ? (a.classList.remove(`${s.containerModifierClass}grid`, `${s.containerModifierClass}grid-column`), e.emitContainerClasses()) : !o && d && (a.classList.add(`${s.containerModifierClass}grid`), (n.grid.fill && "column" === n.grid.fill || !n.grid.fill && "column" === s.grid.fill) && a.classList.add(`${s.containerModifierClass}grid-column`), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach(t => {
					if (void 0 === n[t]) return;
					let i = s[t] && s[t].enabled, a = n[t] && n[t].enabled;
					i && !a && e[t].disable(), !i && a && e[t].enable()
				});
				let c = n.direction && n.direction !== s.direction,
					u = s.loop && (n.slidesPerView !== s.slidesPerView || c), h = s.loop;
				c && i && e.changeDirection(), S(e.params, n);
				let m = e.params.enabled, f = e.params.loop;
				Object.assign(e, {
					allowTouchMove: e.params.allowTouchMove,
					allowSlideNext: e.params.allowSlideNext,
					allowSlidePrev: e.params.allowSlidePrev
				}), p && !m ? e.disable() : !p && m && e.enable(), e.currentBreakpoint = l, e.emit("_beforeBreakpoint", n), i && (u ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !h && f ? (e.loopCreate(t), e.updateSlides()) : h && !f && e.loopDestroy()), e.emit("breakpoint", n)
			}, getBreakpoint: function (e, t, i) {
				if (void 0 === t && (t = "window"), !e || "container" === t && !i) return;
				let s = !1, a = g(), r = "window" === t ? a.innerHeight : i.clientHeight,
					l = Object.keys(e).map(e => "string" == typeof e && 0 === e.indexOf("@") ? {
						value: r * parseFloat(e.substr(1)),
						point: e
					} : {value: e, point: e});
				l.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
				for (let e = 0; e < l.length; e += 1) {
					let {point: r, value: n} = l[e];
					"window" === t ? a.matchMedia(`(min-width: ${n}px)`).matches && (s = r) : n <= i.clientWidth && (s = r)
				}
				return s || "max"
			}
		}, checkOverflow: {
			checkOverflow: function () {
				let {isLocked: e, params: t} = this, {slidesOffsetBefore: i} = t;
				if (i) {
					let e = this.slides.length - 1, t = this.slidesGrid[e] + this.slidesSizesGrid[e] + 2 * i;
					this.isLocked = this.size > t
				} else this.isLocked = 1 === this.snapGrid.length;
				!0 === t.allowSlideNext && (this.allowSlideNext = !this.isLocked), !0 === t.allowSlidePrev && (this.allowSlidePrev = !this.isLocked), e && e !== this.isLocked && (this.isEnd = !1), e !== this.isLocked && this.emit(this.isLocked ? "lock" : "unlock")
			}
		}, classes: {
			addClasses: function () {
				let {classNames: e, params: t, rtl: i, el: s, device: a} = this, r = function (e, t) {
					let i = [];
					return e.forEach(e => {
						"object" == typeof e ? Object.keys(e).forEach(s => {
							e[s] && i.push(t + s)
						}) : "string" == typeof e && i.push(t + e)
					}), i
				}(["initialized", t.direction, {"free-mode": this.params.freeMode && t.freeMode.enabled}, {autoheight: t.autoHeight}, {rtl: i}, {grid: t.grid && t.grid.rows > 1}, {"grid-column": t.grid && t.grid.rows > 1 && "column" === t.grid.fill}, {android: a.android}, {ios: a.ios}, {"css-mode": t.cssMode}, {centered: t.cssMode && t.centeredSlides}, {"watch-progress": t.watchSlidesProgress}], t.containerModifierClass);
				e.push(...r), s.classList.add(...e), this.emitContainerClasses()
			}, removeClasses: function () {
				let {el: e, classNames: t} = this;
				e.classList.remove(...t), this.emitContainerClasses()
			}
		}
	}, K = {};

	class Q {
		constructor() {
			let e, s;
			for (var a, r = arguments.length, l = Array(r), n = 0; n < r; n++) l[n] = arguments[n];
			1 === l.length && l[0].constructor && "Object" === Object.prototype.toString.call(l[0]).slice(8, -1) ? s = l[0] : [e, s] = l, s || (s = {}), s = S({}, s), e && !s.el && (s.el = e);
			let o = m();
			if (s.el && "string" == typeof s.el && o.querySelectorAll(s.el).length > 1) {
				let e = [];
				return o.querySelectorAll(s.el).forEach(t => {
					let i = S({}, s, {el: t});
					e.push(new Q(i))
				}), e
			}
			let d = this;
			d.__swiper__ = !0, d.support = I(), d.device = (a = {userAgent: s.userAgent}, t || (t = function (e) {
				let {userAgent: t} = void 0 === e ? {} : e, i = I(), s = g(), a = s.navigator.platform,
					r = t || s.navigator.userAgent, l = {ios: !1, android: !1}, n = s.screen.width, o = s.screen.height,
					d = r.match(/(Android);?[\s\/]+([\d.]+)?/), p = r.match(/(iPad).*OS\s([\d_]+)/),
					c = r.match(/(iPod)(.*OS\s([\d_]+))?/), u = !p && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
					h = "MacIntel" === a;
				return !p && h && i.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${n}x${o}`) >= 0 && ((p = r.match(/(Version)\/([\d.]+)/)) || (p = [0, 1, "13_0_0"]), h = !1), d && "Win32" !== a && (l.os = "android", l.android = !0), (p || u || c) && (l.os = "ios", l.ios = !0), l
			}(a)), t), d.browser = (i || (i = function () {
				let e = g(), t = !1;

				function i() {
					let t = e.navigator.userAgent.toLowerCase();
					return t.indexOf("safari") >= 0 && 0 > t.indexOf("chrome") && 0 > t.indexOf("android")
				}

				if (i()) {
					let i = String(e.navigator.userAgent);
					if (i.includes("Version/")) {
						let [e, s] = i.split("Version/")[1].split(" ")[0].split(".").map(e => Number(e));
						t = e < 16 || 16 === e && s < 2
					}
				}
				return {
					isSafari: t || i(),
					needPerspectiveFix: t,
					isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
				}
			}()), i), d.eventsListeners = {}, d.eventsAnyListeners = [], d.modules = [...d.__modules__], s.modules && Array.isArray(s.modules) && d.modules.push(...s.modules);
			let p = {};
			d.modules.forEach(e => {
				var t;
				e({
					params: s, swiper: d, extendParams: (t = s, function (e) {
						void 0 === e && (e = {});
						let i = Object.keys(e)[0], s = e[i];
						if ("object" != typeof s || null === s || (!0 === t[i] && (t[i] = {enabled: !0}), "navigation" === i && t[i] && t[i].enabled && !t[i].prevEl && !t[i].nextEl && (t[i].auto = !0), ["pagination", "scrollbar"].indexOf(i) >= 0 && t[i] && t[i].enabled && !t[i].el && (t[i].auto = !0), !(i in t && "enabled" in s))) {
							S(p, e);
							return
						}
						"object" != typeof t[i] || "enabled" in t[i] || (t[i].enabled = !0), t[i] || (t[i] = {enabled: !1}), S(p, e)
					}), on: d.on.bind(d), once: d.once.bind(d), off: d.off.bind(d), emit: d.emit.bind(d)
				})
			});
			let c = S({}, Y, p);
			return d.params = S({}, c, K, s), d.originalParams = S({}, d.params), d.passedParams = S({}, s), d.params && d.params.on && Object.keys(d.params.on).forEach(e => {
				d.on(e, d.params.on[e])
			}), d.params && d.params.onAny && d.onAny(d.params.onAny), Object.assign(d, {
				enabled: d.params.enabled,
				el: e,
				classNames: [],
				slides: [],
				slidesGrid: [],
				snapGrid: [],
				slidesSizesGrid: [],
				isHorizontal: () => "horizontal" === d.params.direction,
				isVertical: () => "vertical" === d.params.direction,
				activeIndex: 0,
				realIndex: 0,
				isBeginning: !0,
				isEnd: !1,
				translate: 0,
				previousTranslate: 0,
				progress: 0,
				velocity: 0,
				animating: !1,
				cssOverflowAdjustment() {
					return 8388608 * Math.trunc(this.translate / 8388608)
				},
				allowSlideNext: d.params.allowSlideNext,
				allowSlidePrev: d.params.allowSlidePrev,
				touchEventsData: {
					isTouched: void 0,
					isMoved: void 0,
					allowTouchCallbacks: void 0,
					touchStartTime: void 0,
					isScrolling: void 0,
					currentTranslate: void 0,
					startTranslate: void 0,
					allowThresholdMove: void 0,
					focusableElements: d.params.focusableElements,
					lastClickTime: 0,
					clickTimeout: void 0,
					velocities: [],
					allowMomentumBounce: void 0,
					startMoving: void 0,
					pointerId: null,
					touchId: null
				},
				allowClick: !0,
				allowTouchMove: d.params.allowTouchMove,
				touches: {startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0},
				imagesToLoad: [],
				imagesLoaded: 0
			}), d.emit("_swiper"), d.params.init && d.init(), d
		}

		getDirectionLabel(e) {
			return this.isHorizontal() ? e : ({
				width: "height",
				"margin-top": "margin-left",
				"margin-bottom ": "margin-right",
				"margin-left": "margin-top",
				"margin-right": "margin-bottom",
				"padding-left": "padding-top",
				"padding-right": "padding-bottom",
				marginRight: "marginBottom"
			})[e]
		}

		getSlideIndex(e) {
			let {slidesEl: t, params: i} = this, s = L(x(t, `.${i.slideClass}, swiper-slide`)[0]);
			return L(e) - s
		}

		getSlideIndexByData(e) {
			return this.getSlideIndex(this.slides.filter(t => 1 * t.getAttribute("data-swiper-slide-index") === e)[0])
		}

		recalcSlides() {
			let {slidesEl: e, params: t} = this;
			this.slides = x(e, `.${t.slideClass}, swiper-slide`)
		}

		enable() {
			this.enabled || (this.enabled = !0, this.params.grabCursor && this.setGrabCursor(), this.emit("enable"))
		}

		disable() {
			this.enabled && (this.enabled = !1, this.params.grabCursor && this.unsetGrabCursor(), this.emit("disable"))
		}

		setProgress(e, t) {
			e = Math.min(Math.max(e, 0), 1);
			let i = this.minTranslate(), s = (this.maxTranslate() - i) * e + i;
			this.translateTo(s, void 0 === t ? 0 : t), this.updateActiveIndex(), this.updateSlidesClasses()
		}

		emitContainerClasses() {
			let e = this;
			if (!e.params._emitClasses || !e.el) return;
			let t = e.el.className.split(" ").filter(t => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass));
			e.emit("_containerClasses", t.join(" "))
		}

		getSlideClasses(e) {
			let t = this;
			return t.destroyed ? "" : e.className.split(" ").filter(e => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass)).join(" ")
		}

		emitSlidesClasses() {
			let e = this;
			if (!e.params._emitClasses || !e.el) return;
			let t = [];
			e.slides.forEach(i => {
				let s = e.getSlideClasses(i);
				t.push({slideEl: i, classNames: s}), e.emit("_slideClass", i, s)
			}), e.emit("_slideClasses", t)
		}

		slidesPerViewDynamic(e, t) {
			void 0 === e && (e = "current"), void 0 === t && (t = !1);
			let {params: i, slides: s, slidesGrid: a, slidesSizesGrid: r, size: l, activeIndex: n} = this, o = 1;
			if ("number" == typeof i.slidesPerView) return i.slidesPerView;
			if (i.centeredSlides) {
				let e, t = s[n] ? s[n].swiperSlideSize : 0;
				for (let i = n + 1; i < s.length; i += 1) s[i] && !e && (t += s[i].swiperSlideSize, o += 1, t > l && (e = !0));
				for (let i = n - 1; i >= 0; i -= 1) s[i] && !e && (t += s[i].swiperSlideSize, o += 1, t > l && (e = !0))
			} else if ("current" === e) for (let e = n + 1; e < s.length; e += 1) (t ? a[e] + r[e] - a[n] < l : a[e] - a[n] < l) && (o += 1); else for (let e = n - 1; e >= 0; e -= 1) a[n] - a[e] < l && (o += 1);
			return o
		}

		update() {
			let e;
			let t = this;
			if (!t || t.destroyed) return;
			let {snapGrid: i, params: s} = t;

			function a() {
				let e = Math.min(Math.max(t.rtlTranslate ? -1 * t.translate : t.translate, t.maxTranslate()), t.minTranslate());
				t.setTranslate(e), t.updateActiveIndex(), t.updateSlidesClasses()
			}

			if (s.breakpoints && t.setBreakpoint(), [...t.el.querySelectorAll('[loading="lazy"]')].forEach(e => {
				e.complete && O(t, e)
			}), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), s.freeMode && s.freeMode.enabled && !s.cssMode) a(), s.autoHeight && t.updateAutoHeight(); else {
				if (("auto" === s.slidesPerView || s.slidesPerView > 1) && t.isEnd && !s.centeredSlides) {
					let i = t.virtual && s.virtual.enabled ? t.virtual.slides : t.slides;
					e = t.slideTo(i.length - 1, 0, !1, !0)
				} else e = t.slideTo(t.activeIndex, 0, !1, !0);
				e || a()
			}
			s.watchOverflow && i !== t.snapGrid && t.checkOverflow(), t.emit("update")
		}

		changeDirection(e, t) {
			void 0 === t && (t = !0);
			let i = this.params.direction;
			return e || (e = "horizontal" === i ? "vertical" : "horizontal"), e === i || "horizontal" !== e && "vertical" !== e || (this.el.classList.remove(`${this.params.containerModifierClass}${i}`), this.el.classList.add(`${this.params.containerModifierClass}${e}`), this.emitContainerClasses(), this.params.direction = e, this.slides.forEach(t => {
				"vertical" === e ? t.style.width = "" : t.style.height = ""
			}), this.emit("changeDirection"), t && this.update()), this
		}

		changeLanguageDirection(e) {
			(!this.rtl || "rtl" !== e) && (this.rtl || "ltr" !== e) && (this.rtl = "rtl" === e, this.rtlTranslate = "horizontal" === this.params.direction && this.rtl, this.rtl ? (this.el.classList.add(`${this.params.containerModifierClass}rtl`), this.el.dir = "rtl") : (this.el.classList.remove(`${this.params.containerModifierClass}rtl`), this.el.dir = "ltr"), this.update())
		}

		mount(e) {
			let t = this;
			if (t.mounted) return !0;
			let i = e || t.params.el;
			if ("string" == typeof i && (i = document.querySelector(i)), !i) return !1;
			i.swiper = t, i.parentNode && i.parentNode.host && "SWIPER-CONTAINER" === i.parentNode.host.nodeName && (t.isElement = !0);
			let s = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`,
				a = i && i.shadowRoot && i.shadowRoot.querySelector ? i.shadowRoot.querySelector(s()) : x(i, s())[0];
			return !a && t.params.createElements && (a = M("div", t.params.wrapperClass), i.append(a), x(i, `.${t.params.slideClass}`).forEach(e => {
				a.append(e)
			})), Object.assign(t, {
				el: i,
				wrapperEl: a,
				slidesEl: t.isElement && !i.parentNode.host.slideSlots ? i.parentNode.host : a,
				hostEl: t.isElement ? i.parentNode.host : i,
				mounted: !0,
				rtl: "rtl" === i.dir.toLowerCase() || "rtl" === P(i, "direction"),
				rtlTranslate: "horizontal" === t.params.direction && ("rtl" === i.dir.toLowerCase() || "rtl" === P(i, "direction")),
				wrongRTL: "-webkit-box" === P(a, "display")
			}), !0
		}

		init(e) {
			let t = this;
			if (t.initialized || !1 === t.mount(e)) return t;
			t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(), t.attachEvents();
			let i = [...t.el.querySelectorAll('[loading="lazy"]')];
			return t.isElement && i.push(...t.hostEl.querySelectorAll('[loading="lazy"]')), i.forEach(e => {
				e.complete ? O(t, e) : e.addEventListener("load", e => {
					O(t, e.target)
				})
			}), D(t), t.initialized = !0, D(t), t.emit("init"), t.emit("afterInit"), t
		}

		destroy(e, t) {
			void 0 === e && (e = !0), void 0 === t && (t = !0);
			let i = this, {params: s, el: a, wrapperEl: r, slides: l} = i;
			return void 0 === i.params || i.destroyed || (i.emit("beforeDestroy"), i.initialized = !1, i.detachEvents(), s.loop && i.loopDestroy(), t && (i.removeClasses(), a.removeAttribute("style"), r.removeAttribute("style"), l && l.length && l.forEach(e => {
				e.classList.remove(s.slideVisibleClass, s.slideFullyVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass), e.removeAttribute("style"), e.removeAttribute("data-swiper-slide-index")
			})), i.emit("destroy"), Object.keys(i.eventsListeners).forEach(e => {
				i.off(e)
			}), !1 !== e && (i.el.swiper = null, function (e) {
				Object.keys(e).forEach(t => {
					try {
						e[t] = null
					} catch (e) {
					}
					try {
						delete e[t]
					} catch (e) {
					}
				})
			}(i)), i.destroyed = !0), null
		}

		static extendDefaults(e) {
			S(K, e)
		}

		static get extendedDefaults() {
			return K
		}

		static get defaults() {
			return Y
		}

		static installModule(e) {
			Q.prototype.__modules__ || (Q.prototype.__modules__ = []);
			let t = Q.prototype.__modules__;
			"function" == typeof e && 0 > t.indexOf(e) && t.push(e)
		}

		static use(e) {
			return Array.isArray(e) ? e.forEach(e => Q.installModule(e)) : Q.installModule(e), Q
		}
	}

	function U(e, t, i, s) {
		return e.params.createElements && Object.keys(s).forEach(a => {
			if (!i[a] && !0 === i.auto) {
				let r = x(e.el, `.${s[a]}`)[0];
				r || ((r = M("div", s[a])).className = s[a], e.el.append(r)), i[a] = r, t[a] = r
			}
		}), i
	}

	function J(e) {
		let {swiper: t, extendParams: i, on: s, emit: a} = e;
		i({
			navigation: {
				nextEl: null,
				prevEl: null,
				hideOnClick: !1,
				disabledClass: "swiper-button-disabled",
				hiddenClass: "swiper-button-hidden",
				lockClass: "swiper-button-lock",
				navigationDisabledClass: "swiper-navigation-disabled"
			}
		}), t.navigation = {nextEl: null, prevEl: null};
		let r = e => (Array.isArray(e) ? e : [e]).filter(e => !!e);

		function l(e) {
			let i;
			return e && "string" == typeof e && t.isElement && (i = t.el.querySelector(e)) ? i : (e && ("string" == typeof e && (i = [...document.querySelectorAll(e)]), t.params.uniqueNavElements && "string" == typeof e && i.length > 1 && 1 === t.el.querySelectorAll(e).length && (i = t.el.querySelector(e))), e && !i) ? e : i
		}

		function n(e, i) {
			let s = t.params.navigation;
			(e = r(e)).forEach(e => {
				e && (e.classList[i ? "add" : "remove"](...s.disabledClass.split(" ")), "BUTTON" === e.tagName && (e.disabled = i), t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](s.lockClass))
			})
		}

		function o() {
			let {nextEl: e, prevEl: i} = t.navigation;
			if (t.params.loop) {
				n(i, !1), n(e, !1);
				return
			}
			n(i, t.isBeginning && !t.params.rewind), n(e, t.isEnd && !t.params.rewind)
		}

		function d(e) {
			e.preventDefault(), (!t.isBeginning || t.params.loop || t.params.rewind) && (t.slidePrev(), a("navigationPrev"))
		}

		function p(e) {
			e.preventDefault(), (!t.isEnd || t.params.loop || t.params.rewind) && (t.slideNext(), a("navigationNext"))
		}

		function c() {
			let e = t.params.navigation;
			if (t.params.navigation = U(t, t.originalParams.navigation, t.params.navigation, {
				nextEl: "swiper-button-next",
				prevEl: "swiper-button-prev"
			}), !(e.nextEl || e.prevEl)) return;
			let i = l(e.nextEl), s = l(e.prevEl);
			Object.assign(t.navigation, {nextEl: i, prevEl: s}), i = r(i), s = r(s);
			let a = (i, s) => {
				i && i.addEventListener("click", "next" === s ? p : d), !t.enabled && i && i.classList.add(...e.lockClass.split(" "))
			};
			i.forEach(e => a(e, "next")), s.forEach(e => a(e, "prev"))
		}

		function u() {
			let {nextEl: e, prevEl: i} = t.navigation;
			e = r(e), i = r(i);
			let s = (e, i) => {
				e.removeEventListener("click", "next" === i ? p : d), e.classList.remove(...t.params.navigation.disabledClass.split(" "))
			};
			e.forEach(e => s(e, "next")), i.forEach(e => s(e, "prev"))
		}

		s("init", () => {
			!1 === t.params.navigation.enabled ? h() : (c(), o())
		}), s("toEdge fromEdge lock unlock", () => {
			o()
		}), s("destroy", () => {
			u()
		}), s("enable disable", () => {
			let {nextEl: e, prevEl: i} = t.navigation;
			if (e = r(e), i = r(i), t.enabled) {
				o();
				return
			}
			[...e, ...i].filter(e => !!e).forEach(e => e.classList.add(t.params.navigation.lockClass))
		}), s("click", (e, i) => {
			let {nextEl: s, prevEl: l} = t.navigation;
			s = r(s), l = r(l);
			let n = i.target;
			if (t.params.navigation.hideOnClick && !l.includes(n) && !s.includes(n)) {
				let e;
				if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === n || t.pagination.el.contains(n))) return;
				s.length ? e = s[0].classList.contains(t.params.navigation.hiddenClass) : l.length && (e = l[0].classList.contains(t.params.navigation.hiddenClass)), !0 === e ? a("navigationShow") : a("navigationHide"), [...s, ...l].filter(e => !!e).forEach(e => e.classList.toggle(t.params.navigation.hiddenClass))
			}
		});
		let h = () => {
			t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")), u()
		};
		Object.assign(t.navigation, {
			enable: () => {
				t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")), c(), o()
			}, disable: h, update: o, init: c, destroy: u
		})
	}

	function Z(e) {
		return void 0 === e && (e = ""), `.${e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`
	}

	function ee(e) {
		let t, {swiper: i, extendParams: s, on: a, emit: r} = e, l = "swiper-pagination";
		s({
			pagination: {
				el: null,
				bulletElement: "span",
				clickable: !1,
				hideOnClick: !1,
				renderBullet: null,
				renderProgressbar: null,
				renderFraction: null,
				renderCustom: null,
				progressbarOpposite: !1,
				type: "bullets",
				dynamicBullets: !1,
				dynamicMainBullets: 1,
				formatFractionCurrent: e => e,
				formatFractionTotal: e => e,
				bulletClass: `${l}-bullet`,
				bulletActiveClass: `${l}-bullet-active`,
				modifierClass: `${l}-`,
				currentClass: `${l}-current`,
				totalClass: `${l}-total`,
				hiddenClass: `${l}-hidden`,
				progressbarFillClass: `${l}-progressbar-fill`,
				progressbarOppositeClass: `${l}-progressbar-opposite`,
				clickableClass: `${l}-clickable`,
				lockClass: `${l}-lock`,
				horizontalClass: `${l}-horizontal`,
				verticalClass: `${l}-vertical`,
				paginationDisabledClass: `${l}-disabled`
			}
		}), i.pagination = {el: null, bullets: []};
		let n = 0, o = e => (Array.isArray(e) ? e : [e]).filter(e => !!e);

		function d() {
			return !i.params.pagination.el || !i.pagination.el || Array.isArray(i.pagination.el) && 0 === i.pagination.el.length
		}

		function p(e, t) {
			let {bulletActiveClass: s} = i.params.pagination;
			e && (e = e[`${"prev" === t ? "previous" : "next"}ElementSibling`]) && (e.classList.add(`${s}-${t}`), (e = e[`${"prev" === t ? "previous" : "next"}ElementSibling`]) && e.classList.add(`${s}-${t}-${t}`))
		}

		function c(e) {
			let t = e.target.closest(Z(i.params.pagination.bulletClass));
			if (!t) return;
			e.preventDefault();
			let s = L(t) * i.params.slidesPerGroup;
			if (i.params.loop) {
				if (i.realIndex === s) return;
				i.slideToLoop(s)
			} else i.slideTo(s)
		}

		function u() {
			let e, s;
			let a = i.rtl, l = i.params.pagination;
			if (d()) return;
			let c = i.pagination.el;
			c = o(c);
			let u = i.virtual && i.params.virtual.enabled ? i.virtual.slides.length : i.slides.length,
				h = i.params.loop ? Math.ceil(u / i.params.slidesPerGroup) : i.snapGrid.length;
			if (i.params.loop ? (s = i.previousRealIndex || 0, e = i.params.slidesPerGroup > 1 ? Math.floor(i.realIndex / i.params.slidesPerGroup) : i.realIndex) : void 0 !== i.snapIndex ? (e = i.snapIndex, s = i.previousSnapIndex) : (s = i.previousIndex || 0, e = i.activeIndex || 0), "bullets" === l.type && i.pagination.bullets && i.pagination.bullets.length > 0) {
				let r, o, d;
				let u = i.pagination.bullets;
				if (l.dynamicBullets && (t = k(u[0], i.isHorizontal() ? "width" : "height", !0), c.forEach(e => {
					e.style[i.isHorizontal() ? "width" : "height"] = `${t * (l.dynamicMainBullets + 4)}px`
				}), l.dynamicMainBullets > 1 && void 0 !== s && ((n += e - (s || 0)) > l.dynamicMainBullets - 1 ? n = l.dynamicMainBullets - 1 : n < 0 && (n = 0)), d = ((o = (r = Math.max(e - n, 0)) + (Math.min(u.length, l.dynamicMainBullets) - 1)) + r) / 2), u.forEach(e => {
					let t = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(e => `${l.bulletActiveClass}${e}`)].map(e => "string" == typeof e && e.includes(" ") ? e.split(" ") : e).flat();
					e.classList.remove(...t)
				}), c.length > 1) u.forEach(t => {
					let s = L(t);
					s === e ? t.classList.add(...l.bulletActiveClass.split(" ")) : i.isElement && t.setAttribute("part", "bullet"), l.dynamicBullets && (s >= r && s <= o && t.classList.add(...`${l.bulletActiveClass}-main`.split(" ")), s === r && p(t, "prev"), s === o && p(t, "next"))
				}); else {
					let t = u[e];
					if (t && t.classList.add(...l.bulletActiveClass.split(" ")), i.isElement && u.forEach((t, i) => {
						t.setAttribute("part", i === e ? "bullet-active" : "bullet")
					}), l.dynamicBullets) {
						let e = u[r], t = u[o];
						for (let e = r; e <= o; e += 1) u[e] && u[e].classList.add(...`${l.bulletActiveClass}-main`.split(" "));
						p(e, "prev"), p(t, "next")
					}
				}
				if (l.dynamicBullets) {
					let e = Math.min(u.length, l.dynamicMainBullets + 4), s = (t * e - t) / 2 - d * t,
						r = a ? "right" : "left";
					u.forEach(e => {
						e.style[i.isHorizontal() ? r : "top"] = `${s}px`
					})
				}
			}
			c.forEach((t, s) => {
				if ("fraction" === l.type && (t.querySelectorAll(Z(l.currentClass)).forEach(t => {
					t.textContent = l.formatFractionCurrent(e + 1)
				}), t.querySelectorAll(Z(l.totalClass)).forEach(e => {
					e.textContent = l.formatFractionTotal(h)
				})), "progressbar" === l.type) {
					let s;
					s = l.progressbarOpposite ? i.isHorizontal() ? "vertical" : "horizontal" : i.isHorizontal() ? "horizontal" : "vertical";
					let a = (e + 1) / h, r = 1, n = 1;
					"horizontal" === s ? r = a : n = a, t.querySelectorAll(Z(l.progressbarFillClass)).forEach(e => {
						e.style.transform = `translate3d(0,0,0) scaleX(${r}) scaleY(${n})`, e.style.transitionDuration = `${i.params.speed}ms`
					})
				}
				"custom" === l.type && l.renderCustom ? (t.innerHTML = l.renderCustom(i, e + 1, h), 0 === s && r("paginationRender", t)) : (0 === s && r("paginationRender", t), r("paginationUpdate", t)), i.params.watchOverflow && i.enabled && t.classList[i.isLocked ? "add" : "remove"](l.lockClass)
			})
		}

		function h() {
			let e = i.params.pagination;
			if (d()) return;
			let t = i.virtual && i.params.virtual.enabled ? i.virtual.slides.length : i.grid && i.params.grid.rows > 1 ? i.slides.length / Math.ceil(i.params.grid.rows) : i.slides.length,
				s = i.pagination.el;
			s = o(s);
			let a = "";
			if ("bullets" === e.type) {
				let s = i.params.loop ? Math.ceil(t / i.params.slidesPerGroup) : i.snapGrid.length;
				i.params.freeMode && i.params.freeMode.enabled && s > t && (s = t);
				for (let t = 0; t < s; t += 1) e.renderBullet ? a += e.renderBullet.call(i, t, e.bulletClass) : a += `<${e.bulletElement} ${i.isElement ? 'part="bullet"' : ""} class="${e.bulletClass}"></${e.bulletElement}>`
			}
			"fraction" === e.type && (a = e.renderFraction ? e.renderFraction.call(i, e.currentClass, e.totalClass) : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`), "progressbar" === e.type && (a = e.renderProgressbar ? e.renderProgressbar.call(i, e.progressbarFillClass) : `<span class="${e.progressbarFillClass}"></span>`), i.pagination.bullets = [], s.forEach(t => {
				"custom" !== e.type && (t.innerHTML = a || ""), "bullets" === e.type && i.pagination.bullets.push(...t.querySelectorAll(Z(e.bulletClass)))
			}), "custom" !== e.type && r("paginationRender", s[0])
		}

		function m() {
			let e;
			i.params.pagination = U(i, i.originalParams.pagination, i.params.pagination, {el: "swiper-pagination"});
			let t = i.params.pagination;
			t.el && ("string" == typeof t.el && i.isElement && (e = i.el.querySelector(t.el)), e || "string" != typeof t.el || (e = [...document.querySelectorAll(t.el)]), e || (e = t.el), e && 0 !== e.length && (i.params.uniqueNavElements && "string" == typeof t.el && Array.isArray(e) && e.length > 1 && (e = [...i.el.querySelectorAll(t.el)]).length > 1 && (e = e.filter(e => A(e, ".swiper")[0] === i.el)[0]), Array.isArray(e) && 1 === e.length && (e = e[0]), Object.assign(i.pagination, {el: e}), (e = o(e)).forEach(e => {
				"bullets" === t.type && t.clickable && e.classList.add(...(t.clickableClass || "").split(" ")), e.classList.add(t.modifierClass + t.type), e.classList.add(i.isHorizontal() ? t.horizontalClass : t.verticalClass), "bullets" === t.type && t.dynamicBullets && (e.classList.add(`${t.modifierClass}${t.type}-dynamic`), n = 0, t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)), "progressbar" === t.type && t.progressbarOpposite && e.classList.add(t.progressbarOppositeClass), t.clickable && e.addEventListener("click", c), i.enabled || e.classList.add(t.lockClass)
			})))
		}

		function f() {
			let e = i.params.pagination;
			if (d()) return;
			let t = i.pagination.el;
			t && (t = o(t)).forEach(t => {
				t.classList.remove(e.hiddenClass), t.classList.remove(e.modifierClass + e.type), t.classList.remove(i.isHorizontal() ? e.horizontalClass : e.verticalClass), e.clickable && (t.classList.remove(...(e.clickableClass || "").split(" ")), t.removeEventListener("click", c))
			}), i.pagination.bullets && i.pagination.bullets.forEach(t => t.classList.remove(...e.bulletActiveClass.split(" ")))
		}

		a("changeDirection", () => {
			if (!i.pagination || !i.pagination.el) return;
			let e = i.params.pagination, {el: t} = i.pagination;
			(t = o(t)).forEach(t => {
				t.classList.remove(e.horizontalClass, e.verticalClass), t.classList.add(i.isHorizontal() ? e.horizontalClass : e.verticalClass)
			})
		}), a("init", () => {
			!1 === i.params.pagination.enabled ? g() : (m(), h(), u())
		}), a("activeIndexChange", () => {
			void 0 === i.snapIndex && u()
		}), a("snapIndexChange", () => {
			u()
		}), a("snapGridLengthChange", () => {
			h(), u()
		}), a("destroy", () => {
			f()
		}), a("enable disable", () => {
			let {el: e} = i.pagination;
			e && (e = o(e)).forEach(e => e.classList[i.enabled ? "remove" : "add"](i.params.pagination.lockClass))
		}), a("lock unlock", () => {
			u()
		}), a("click", (e, t) => {
			let s = t.target, a = o(i.pagination.el);
			if (i.params.pagination.el && i.params.pagination.hideOnClick && a && a.length > 0 && !s.classList.contains(i.params.pagination.bulletClass)) {
				if (i.navigation && (i.navigation.nextEl && s === i.navigation.nextEl || i.navigation.prevEl && s === i.navigation.prevEl)) return;
				!0 === a[0].classList.contains(i.params.pagination.hiddenClass) ? r("paginationShow") : r("paginationHide"), a.forEach(e => e.classList.toggle(i.params.pagination.hiddenClass))
			}
		});
		let g = () => {
			i.el.classList.add(i.params.pagination.paginationDisabledClass);
			let {el: e} = i.pagination;
			e && (e = o(e)).forEach(e => e.classList.add(i.params.pagination.paginationDisabledClass)), f()
		};
		Object.assign(i.pagination, {
			enable: () => {
				i.el.classList.remove(i.params.pagination.paginationDisabledClass);
				let {el: e} = i.pagination;
				e && (e = o(e)).forEach(e => e.classList.remove(i.params.pagination.paginationDisabledClass)), m(), h(), u()
			}, disable: g, render: h, update: u, init: m, destroy: f
		})
	}

	function et(e) {
		let t, i, s, a, r, l, n, o, d, p, {swiper: c, extendParams: u, on: h, emit: f, params: g} = e;
		c.autoplay = {running: !1, paused: !1, timeLeft: 0}, u({
			autoplay: {
				enabled: !1,
				delay: 3e3,
				waitForTransition: !0,
				disableOnInteraction: !1,
				stopOnLastSlide: !1,
				reverseDirection: !1,
				pauseOnMouseEnter: !1
			}
		});
		let v = g && g.autoplay ? g.autoplay.delay : 3e3, b = g && g.autoplay ? g.autoplay.delay : 3e3,
			w = new Date().getTime();

		function S(e) {
			c && !c.destroyed && c.wrapperEl && e.target === c.wrapperEl && (c.wrapperEl.removeEventListener("transitionend", S), p || P())
		}

		let y = () => {
			if (c.destroyed || !c.autoplay.running) return;
			c.autoplay.paused ? a = !0 : a && (b = s, a = !1);
			let e = c.autoplay.paused ? s : w + b - new Date().getTime();
			c.autoplay.timeLeft = e, f("autoplayTimeLeft", e, e / v), i = requestAnimationFrame(() => {
				y()
			})
		}, E = () => {
			let e;
			if (e = c.virtual && c.params.virtual.enabled ? c.slides.filter(e => e.classList.contains("swiper-slide-active"))[0] : c.slides[c.activeIndex]) return parseInt(e.getAttribute("data-swiper-autoplay"), 10)
		}, T = e => {
			if (c.destroyed || !c.autoplay.running) return;
			cancelAnimationFrame(i), y();
			let a = void 0 === e ? c.params.autoplay.delay : e;
			v = c.params.autoplay.delay, b = c.params.autoplay.delay;
			let r = E();
			!Number.isNaN(r) && r > 0 && void 0 === e && (a = r, v = r, b = r), s = a;
			let l = c.params.speed, n = () => {
				c && !c.destroyed && (c.params.autoplay.reverseDirection ? !c.isBeginning || c.params.loop || c.params.rewind ? (c.slidePrev(l, !0, !0), f("autoplay")) : c.params.autoplay.stopOnLastSlide || (c.slideTo(c.slides.length - 1, l, !0, !0), f("autoplay")) : !c.isEnd || c.params.loop || c.params.rewind ? (c.slideNext(l, !0, !0), f("autoplay")) : c.params.autoplay.stopOnLastSlide || (c.slideTo(0, l, !0, !0), f("autoplay")), c.params.cssMode && (w = new Date().getTime(), requestAnimationFrame(() => {
					T()
				})))
			};
			return a > 0 ? (clearTimeout(t), t = setTimeout(() => {
				n()
			}, a)) : requestAnimationFrame(() => {
				n()
			}), a
		}, x = () => {
			w = new Date().getTime(), c.autoplay.running = !0, T(), f("autoplayStart")
		}, C = () => {
			c.autoplay.running = !1, clearTimeout(t), cancelAnimationFrame(i), f("autoplayStop")
		}, M = (e, i) => {
			if (c.destroyed || !c.autoplay.running) return;
			clearTimeout(t), e || (d = !0);
			let a = () => {
				f("autoplayPause"), c.params.autoplay.waitForTransition ? c.wrapperEl.addEventListener("transitionend", S) : P()
			};
			if (c.autoplay.paused = !0, i) {
				o && (s = c.params.autoplay.delay), o = !1, a();
				return
			}
			s = (s || c.params.autoplay.delay) - (new Date().getTime() - w), c.isEnd && s < 0 && !c.params.loop || (s < 0 && (s = 0), a())
		}, P = () => {
			c.isEnd && s < 0 && !c.params.loop || c.destroyed || !c.autoplay.running || (w = new Date().getTime(), d ? (d = !1, T(s)) : T(), c.autoplay.paused = !1, f("autoplayResume"))
		}, L = () => {
			if (c.destroyed || !c.autoplay.running) return;
			let e = m();
			"hidden" === e.visibilityState && (d = !0, M(!0)), "visible" === e.visibilityState && P()
		}, A = e => {
			"mouse" === e.pointerType && (d = !0, p = !0, c.animating || c.autoplay.paused || M(!0))
		}, k = e => {
			"mouse" === e.pointerType && (p = !1, c.autoplay.paused && P())
		}, I = () => {
			c.params.autoplay.pauseOnMouseEnter && (c.el.addEventListener("pointerenter", A), c.el.addEventListener("pointerleave", k))
		}, O = () => {
			c.el.removeEventListener("pointerenter", A), c.el.removeEventListener("pointerleave", k)
		}, z = () => {
			m().addEventListener("visibilitychange", L)
		}, D = () => {
			m().removeEventListener("visibilitychange", L)
		};
		h("init", () => {
			c.params.autoplay.enabled && (I(), z(), x())
		}), h("destroy", () => {
			O(), D(), c.autoplay.running && C()
		}), h("_freeModeStaticRelease", () => {
			(l || d) && P()
		}), h("_freeModeNoMomentumRelease", () => {
			c.params.autoplay.disableOnInteraction ? C() : M(!0, !0)
		}), h("beforeTransitionStart", (e, t, i) => {
			!c.destroyed && c.autoplay.running && (i || !c.params.autoplay.disableOnInteraction ? M(!0, !0) : C())
		}), h("sliderFirstMove", () => {
			if (!c.destroyed && c.autoplay.running) {
				if (c.params.autoplay.disableOnInteraction) {
					C();
					return
				}
				r = !0, l = !1, d = !1, n = setTimeout(() => {
					d = !0, l = !0, M(!0)
				}, 200)
			}
		}), h("touchEnd", () => {
			if (!c.destroyed && c.autoplay.running && r) {
				if (clearTimeout(n), clearTimeout(t), c.params.autoplay.disableOnInteraction) {
					l = !1, r = !1;
					return
				}
				l && c.params.cssMode && P(), l = !1, r = !1
			}
		}), h("slideChange", () => {
			!c.destroyed && c.autoplay.running && (o = !0)
		}), Object.assign(c.autoplay, {start: x, stop: C, pause: M, resume: P})
	}

	function ei(e) {
		let {swiper: t, extendParams: i, on: s} = e;
		i({fadeEffect: {crossFade: !1}}), function (e) {
			let t;
			let {
				effect: i,
				swiper: s,
				on: a,
				setTranslate: r,
				setTransition: l,
				overwriteParams: n,
				perspective: o,
				recreateShadows: d,
				getEffectParams: p
			} = e;
			a("beforeInit", () => {
				if (s.params.effect !== i) return;
				s.classNames.push(`${s.params.containerModifierClass}${i}`), o && o() && s.classNames.push(`${s.params.containerModifierClass}3d`);
				let e = n ? n() : {};
				Object.assign(s.params, e), Object.assign(s.originalParams, e)
			}), a("setTranslate", () => {
				s.params.effect === i && r()
			}), a("setTransition", (e, t) => {
				s.params.effect === i && l(t)
			}), a("transitionEnd", () => {
				s.params.effect === i && d && p && p().slideShadows && (s.slides.forEach(e => {
					e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(e => e.remove())
				}), d())
			}), a("virtualUpdate", () => {
				s.params.effect === i && (s.slides.length || (t = !0), requestAnimationFrame(() => {
					t && s.slides && s.slides.length && (r(), t = !1)
				}))
			})
		}({
			effect: "fade",
			swiper: t,
			on: s,
			setTranslate: () => {
				let {slides: e} = t;
				t.params.fadeEffect;
				for (let i = 0; i < e.length; i += 1) {
					let e = t.slides[i], s = -e.swiperSlideOffset;
					t.params.virtualTranslate || (s -= t.translate);
					let a = 0;
					t.isHorizontal() || (a = s, s = 0);
					let r = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(e.progress), 0) : 1 + Math.min(Math.max(e.progress, -1), 0),
						l = function (e, t) {
							let i = T(t);
							return i !== t && (i.style.backfaceVisibility = "hidden", i.style["-webkit-backface-visibility"] = "hidden"), i
						}(0, e);
					l.style.opacity = r, l.style.transform = `translate3d(${s}px, ${a}px, 0px)`
				}
			},
			setTransition: e => {
				let i = t.slides.map(e => T(e));
				i.forEach(t => {
					t.style.transitionDuration = `${e}ms`
				}), function (e) {
					let {swiper: t, duration: i, transformElements: s, allSlides: a} = e, {activeIndex: r} = t,
						l = e => e.parentElement ? e.parentElement : t.slides.filter(t => t.shadowRoot && t.shadowRoot === e.parentNode)[0];
					if (t.params.virtualTranslate && 0 !== i) {
						let e = !1;
						(a ? s : s.filter(e => {
							let i = e.classList.contains("swiper-slide-transform") ? l(e) : e;
							return t.getSlideIndex(i) === r
						})).forEach(i => {
							var s;
							(s = () => {
								if (e || !t || t.destroyed) return;
								e = !0, t.animating = !1;
								let i = new window.CustomEvent("transitionend", {bubbles: !0, cancelable: !0});
								t.wrapperEl.dispatchEvent(i)
							}) && i.addEventListener("transitionend", function e(t) {
								t.target === i && (s.call(i, t), i.removeEventListener("transitionend", e))
							})
						})
					}
				}({swiper: t, duration: e, transformElements: i, allSlides: !0})
			},
			overwriteParams: () => ({
				slidesPerView: 1,
				slidesPerGroup: 1,
				watchSlidesProgress: !0,
				spaceBetween: 0,
				virtualTranslate: !t.params.cssMode
			})
		})
	}

	Object.keys(X).forEach(e => {
		Object.keys(X[e]).forEach(t => {
			Q.prototype[t] = X[e][t]
		})
	}), Q.use([function (e) {
		let {swiper: t, on: i, emit: s} = e, a = g(), r = null, l = null, n = () => {
			t && !t.destroyed && t.initialized && (s("beforeResize"), s("resize"))
		}, o = () => {
			t && !t.destroyed && t.initialized && (r = new ResizeObserver(e => {
				l = a.requestAnimationFrame(() => {
					let {width: i, height: s} = t, a = i, r = s;
					e.forEach(e => {
						let {contentBoxSize: i, contentRect: s, target: l} = e;
						l && l !== t.el || (a = s ? s.width : (i[0] || i).inlineSize, r = s ? s.height : (i[0] || i).blockSize)
					}), (a !== i || r !== s) && n()
				})
			})).observe(t.el)
		}, d = () => {
			l && a.cancelAnimationFrame(l), r && r.unobserve && t.el && (r.unobserve(t.el), r = null)
		}, p = () => {
			t && !t.destroyed && t.initialized && s("orientationchange")
		};
		i("init", () => {
			if (t.params.resizeObserver && void 0 !== a.ResizeObserver) {
				o();
				return
			}
			a.addEventListener("resize", n), a.addEventListener("orientationchange", p)
		}), i("destroy", () => {
			d(), a.removeEventListener("resize", n), a.removeEventListener("orientationchange", p)
		})
	}, function (e) {
		let {swiper: t, extendParams: i, on: s, emit: a} = e, r = [], l = g(), n = function (e, i) {
			void 0 === i && (i = {});
			let s = new (l.MutationObserver || l.WebkitMutationObserver)(e => {
				if (t.__preventObserver__) return;
				if (1 === e.length) {
					a("observerUpdate", e[0]);
					return
				}
				let i = function () {
					a("observerUpdate", e[0])
				};
				l.requestAnimationFrame ? l.requestAnimationFrame(i) : l.setTimeout(i, 0)
			});
			s.observe(e, {
				attributes: void 0 === i.attributes || i.attributes,
				childList: void 0 === i.childList || i.childList,
				characterData: void 0 === i.characterData || i.characterData
			}), r.push(s)
		};
		i({observer: !1, observeParents: !1, observeSlideChildren: !1}), s("init", () => {
			if (t.params.observer) {
				if (t.params.observeParents) {
					let e = A(t.hostEl);
					for (let t = 0; t < e.length; t += 1) n(e[t])
				}
				n(t.hostEl, {childList: t.params.observeSlideChildren}), n(t.wrapperEl, {attributes: !1})
			}
		}), s("destroy", () => {
			r.forEach(e => {
				e.disconnect()
			}), r.splice(0, r.length)
		})
	}]);

	class es extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.sliderEl = this.querySelector(".js-slider"), this.slidesEls = this.sliderEl.querySelectorAll(".js-slide"), this.isSliderMobileOnly = this.sliderEl.hasAttribute("mobile-only") || !1, this.isSliderDesktopOnly = this.sliderEl.hasAttribute("desktop-only") || !1, this.listenToResize = this.sliderEl.hasAttribute("resize") || !0, this.minimumLength = Number(this.sliderEl.getAttribute("minimum-length")) || 1, this.isNumberedPagination = this.sliderEl.hasAttribute("numbered-pagination") || !1, this.spaceBetween = Number(this.sliderEl.getAttribute("space-between")) || 0, this.slidesPerView = Number(this.sliderEl.getAttribute("slides-per-view")) || "auto", this.slidesPerGroup = Number(this.sliderEl.getAttribute("slides-per-group")) || !1, this.initialSlide = Number(this.sliderEl.getAttribute("initial-slide")) || 0, this.breakpoints = JSON.parse(this.sliderEl.getAttribute("breakpoints")) || null, this.mobileBreakpoint = 1024, this.prevElSelector = this.sliderEl.getAttribute("prev-el") || "", this.nextElSelector = this.sliderEl.getAttribute("next-el") || "", this.paginationElSelector = this.sliderEl.getAttribute("pagination") || "", this.paginationElSelector && (this.paginationEl = document.querySelector(this.paginationElSelector)), this.prevElSelector && (this.prevEl = document.querySelector(this.prevElSelector)), this.nextElSelector && (this.nextEl = document.querySelector(this.nextElSelector)), this.listenToResize && window.addEventListener("resize", () => {
				this.checkSlider()
			}), this.checkSlider()
		}

		checkSlider() {
			if (this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches, this.isSliderMobileOnly && !this.isMobile || 1 === this.slidesEls.length || this.slidesEls.length < this.minimumLength || this.isMobile && this.isSliderDesktopOnly) {
				this.hideArrows(), this.Slider && this.destroySlider();
				return
			}
			this.createSliderSettings()
		}

		createSliderSettings() {
			this.autoplay = this.sliderEl.hasAttribute("autoplay") || !1, this.loop = this.sliderEl.hasAttribute("loop") || !1, this.fade = this.sliderEl.hasAttribute("fade") || !1, this.freeMode = this.sliderEl.hasAttribute("free-mode") || !1, this.disableSlide = this.sliderEl.hasAttribute("disable-slide") || !1, this.touchStartAllow = this.sliderEl.hasAttribute("touch-start") || !1, this.watchOverflow = this.sliderEl.hasAttribute("watch-overflow") || !1, this.speed = parseInt(this.sliderEl.getAttribute("speed")) || 700, this.autoplayDelay = parseInt(this.sliderEl.getAttribute("autoplay-delay")) || 3e3, this.direction = this.sliderEl.getAttribute("direction") || "horizontal", this.sliderSettings = {
				modules: [J, ee, et, ei],
				init: !1,
				direction: this.direction,
				slidesPerView: this.slidesPerView,
				freeMode: this.freeMode,
				speed: this.speed,
				loop: this.loop,
				loopPreventsSlide: !1,
				allowTouchMove: !this.disableSlide,
				autoplay: this.autoplay,
				touchStartPreventDefault: !1
			}, this.fade && (this.sliderSettings.effect = "fade", this.sliderSettings.fadeEffect = {crossFade: !0}), this.autoplay && (this.sliderSettings.autoplay = {delay: this.autoplayDelay}), 0 != this.spaceBetween && (this.sliderSettings.spaceBetween = this.spaceBetween), this.slidesPerGroup && (this.sliderSettings.slidesPerGroup = this.slidesPerGroup), 0 != this.initialSlide && (this.sliderSettings.initialSlide = this.initialSlide), this.prevEl && this.nextEl && (this.sliderSettings.navigation = {
				prevEl: this.prevEl,
				nextEl: this.nextEl,
				disabledClass: "swiper-button-disabled"
			}), this.paginationEl && (this.sliderSettings.pagination = {
				el: this.paginationEl,
				clickable: !0,
				bulletClass: "slider-pagination-bullet",
				bulletActiveClass: "slider-pagination-bullet--active"
			}), this.isNumberedPagination && (this.sliderSettings.pagination.renderBullet = function (e, t) {
				return '<div class="' + t + ' h5 slider-pagination-numbered"><span>' + (e + 1 < 10 ? "0" + (e + 1) : (e + 1).toString()) + "</span></div>"
			}), this.isMobile && !this.disableSlide && (this.sliderSettings.allowTouchMove = !0), null != this.breakpoints && (this.sliderSettings.breakpoints = this.breakpoints), this.loop || 0 != this.initialSlide || (this.sliderSettings.on = {
				init: () => {
					this.prevEl?.classList.add("swiper-button-disabled")
				}
			}), this.watchOverflow && (this.sliderSettings.on = {
				resize: e => {
					!this.sliderEl.classList.contains("swiper-active") && e.virtualSize > e.size ? this.sliderEl.classList.add("swiper-active") : this.sliderEl.classList.contains("swiper-active") && e.virtualSize <= e.size && this.sliderEl.classList.remove("swiper-active")
				}
			}), this.sliderSettings && this.initSlider()
		}

		initSlider() {
			this.sliderEl && this.sliderSettings && (this.destroySlider(), this.Slider = new Q(this.sliderEl, this.sliderSettings), this.Slider.init())
		}

		destroySlider() {
			this.Slider && this.Slider.destroy(!0, !0)
		}

		hideArrows() {
			this.nextEl?.classList.add("swiper-button-disabled"), this.prevEl?.classList.add("swiper-button-disabled")
		}
	}

	void 0 === customElements.get("w3-slider") && customElements.define("w3-slider", es), void 0 === customElements.get("w3-product-slider") && customElements.define("w3-product-slider", class extends es {
		constructor() {
			super(), this.onKeyboardPagination = this.onKeyboardPagination.bind(this)
		}

		initSlider() {
			super.initSlider(), this.bindProductSliderEvents()
		}

		bindProductSliderEvents() {
			this.hasVideo = this.sliderEl.hasAttribute("has-video") || !1, this.customPaginationIndex = this.sliderEl.hasAttribute("custom-pagination-index") || !1, this.customPaginationElSelector = this.sliderEl.getAttribute("custom-pagination-el") || "", this.customPaginationElSelector && (this.customPaginationEls = document.querySelectorAll(this.customPaginationElSelector)), this.hasVideo && (this.videosEls = this.sliderEl.querySelectorAll("video"), this.launchVideoOnSlide(this.Slider.slides[this.Slider.activeIndex]), this.Slider.on("activeIndexChange", e => {
				this.launchVideoOnSlide(e.slides[e.activeIndex])
			})), document.addEventListener("keyup", this.onKeyboardPagination), this.customPaginationEls && this.initCustomPagination()
		}

		onKeyboardPagination(e) {
			switch (e.keyCode) {
				case 37:
					this.Slider.slidePrev();
					break;
				case 39:
					this.Slider.slideNext()
			}
		}

		launchVideoOnSlide(e) {
			if (e.hasAttribute("slide-has-video")) {
				for (let e = 0; e < this.videosEls.length; e++) this.videosEls[e].pause(), this.videosEls[e].currentTime = 0;
				for (let t of e.querySelectorAll("video")) t.play()
			}
		}

		initCustomPagination() {
			for (let e of this.customPaginationEls) {
				let t = e.querySelectorAll(`${this.customPaginationIndex ? "[data-custom-index]" : "[data-index]"}`);
				if (!t || 1 === t) {
					i = !0;
					return
				}
				let i = !0, s = t[0];
				s.classList.add("active"), this.Slider.on("activeIndexChange", e => {
					let i = this.customPaginationIndex ? e.slidesEl.children[e.activeIndex].dataset.customIndex : e.slides[e.activeIndex].dataset.index;
					s.classList.remove("active"), t[i].classList.add("active"), s = t[i]
				}), t.forEach(e => {
					e.addEventListener("click", () => {
						i && (i = !1, this.isLoop ? this.Slider.slideToLoop(Number(this.customPaginationIndex ? e.dataset.customIndex : e.dataset.index), this.speed) : this.Slider.slideTo(Number(this.customPaginationIndex ? e.dataset.customIndex : e.dataset.index), this.speed), s.classList.remove("active"), e.classList.add("active"), s = e, setTimeout(() => {
							i = !0
						}, this.speed))
					})
				}), this.nextSelector && (this.nextEl = document.querySelector(this.nextSelector))
			}
		}
	})
}();